import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import axios from 'axios';

import settings from '../libs/config';
import Logger from '../functions/logging';
import FadeIn from '../components/global/FadeIn';
import PageLoader from '../components/global/PageLoader';
import PilotlyModal from '../components/global/PilotlyModal';
import Feedback from '../components/global/Feedback';
import SVOD from './SVOD';
import {
	isNumber,
	isCurrentSVODEnvironmentPage,
	isAppleTVGuidedTargetPrompt,
	isTargetAssetShowPagePrompt,
	returnAnswerAndPathIdsFromSurvey
} from '../functions/utils';

import localeMessages from '../locales/player';
import svodModalMessages from '../locales/svodModals';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button } from 'react-materialize';

import * as auth from '../functions/auth';
import * as helpers from '../functions/helpers';
import * as TargetProcess from '../functions/targetProcess';
import * as PANEL_HELPERS from '../functions/panels';

import { Survey } from '@groupflix/survey/build/index';

import { getStudyPanel } from '../api/panels';
import { createPanelResponse, createSVODResponses } from '../api/responses';
import { getAssetComments, postAssetComment } from '../api/viewerComments';
import { setFetchedPanel } from '../redux/actions/index';
import { toggleActiveSurvey, setSelectedAsset } from '../redux/actions/SVOD';
import * as SCREEN_CODES from '../constants/screenCodes';
import * as SCREEN_REASONS from '../constants/screenReasons';

import SVODStatus from '../analytics/analytics-events/SVODStatus';
import { SVODStatusEvent } from '../analytics/analytics-events/constants';
import { EnvType, ROW_LABELS } from '../components/svod/constants';
import { updateUserSubscription } from '../api/user';

const TIMEOUT_LIMIT = 1800;
const CURATED_PROMPT_LIMIT = 120; // 2 min
const PROMPT_WATCH_PAGE_INTERVAL = 30000; // 30 seconds

let APPLE_GUIDED_EXPERIENCE_LIMIT = 300; // 5 min
const APPLE_GUIDED_ADDED_LIMIT = 180; // setting the next prompt to 3 min
const APPLE_FORCE_GUIDED_EXPERIENCE_LIMIT = 180; // the forced prompt appears 3 min after the final guided prompt

const TIME_ENTERING_EXIT_SURVEY = 180000; // 3 min after the last prompt
const APPLE_GUIDED_PROCEEDING_EXPERIENCE_LIMIT = 60; // 1min // 300; // 5 min
const MINIMUM_PERCENT = 1;
const MINIMUM_TIME_ENGAGED = 2; // (seconds)
const PANEL_RESPONSE_SUBMIT_LIMIT = 3;
const APPLE_PROMPT_LIMIT = 2;

const PEACOCK_CURATED_INTERVAL = 15000; // 15 seconds
const HOMEPAGE_PROMPT_INTERVAL = 15000; // 15 seconds
const FORCED_ASSET_EXPOSURE_INTERVAL = 180000; // 3 min

// exclusively for development. Clicking the `Watch Now` tab in the Apple SVOD Env will trigger the exit survey
const IS_DEVELOPMENT_ENV = helpers.isPilotlyDevelopment(process.env.REACT_APP_ENV);

class EnvironmentContainer extends Component {
	constructor(props) {
		super(props);

		let initTime = Date.now();
		this.state = {
			assetsInfoMap: {},
			rowInfoMap: {},
			midRowInfoMap: {},
			myListInfoMap: {},
			questionSetIndex: 0,
			questionIndex: 0,
			questionSetMap: {},
			questionMap: {},
			maxQsetIndex: null,

			pathTracker: [],
			answerTracker: [],
			qset_asset: '',

			// When a user takes a positive action a token is taken from the allotment
			// and added to their token count.
			// Negative actions cause a token to be taken from the token count.
			// If tokens goes to 0, the next negative action terminates the user as a bad respondant
			goodwill: {
				tokens: 1, // viewer starts with 1 token as they initially start at the prerollList (qset_index = 0)
				allotment: {
					inVideoSurvey: 2,
					prerollList: 1,
					postrollList: 1
				}
			},

			viewCount: 0,
			commentCount: 0,
			fullscreensWatched: {},
			trailersWatched: {},
			promosWatched: {},
			questionSetsDisplayed: [0],
			currentTrailerAsset: null,
			currentAssetComments: [],

			// enableSurveySet: false, // for testing SVOD
			enableSurveySet: true, // temporary parameter to render invideo set survey
			feedbackType: null,

			currentPage: {},
			currentModal: {},

			environmentResponse: {
				environment_id: this.props.fetchedGroup.svod_env._id,
				total_time_in_env: 0,
				start_time_in_env: null,
				end_time_in_env: null,
				asset_activity: [],
				row_activity: [],
				mid_row_activity: {},
				my_list_activity: {},
				page_activity: {},
				modal_activity: {},
				modal_button_click_activity: [],
				thumbnail_click_activity: [],
				billboard_click_activity: [],
				highlight_click_activity: [],
				player_activity: [],
				button_click_activity: [],
				asset_watch_progress: {},
			},

			submittedSVODQuestions: {},
			watchingFullScreen: false,
			endSVODExperience: false,
			beganSVODExperienceTime: null,
			promptReturnToHomePage: false,
			promptCuratedRow: false,
			promptTargetAsset: false,
			promptForcedTargetAsset: false,
			promptWatchPage: false,
			beginAppleGuidedExperience: false,
			forceGuidedExperience: false,

			promptedTargetAsset: false,
			promptedForceTargetAsset: false,
			autoNavigateToTargetAsset: false,
			autoNavigateToIncludedAppleTVPage: false,
			confirmedFinalStep: false,
			timeInSVOD: 0,
			returnToContentPromptCount: 0,
			isFirstSVODLoad: true,

			modalTitle: '',
			modalMessage: '',
			modalBackgroundCover: false,

			backRoute: '/study',
			targetAssetIndex: 0,
			svodStartTime: 0,
			svodContinueTime: 0,
			totalModalTime: 0,

			billboardAsset: null,

			userActiveTimer: null
		};

		this.isTester = !!TargetProcess.isTester(this.props.targetParams);

		this.interval = {};
		this.curatedInterval = {};
		this.promptToHomePageInterval = {};
		this.targetAssetInterval = {};
		this.forcedTargetAssetInterval = {};
		this.watchPageInterval = {};
		this.beginGuidedExperienceInterval = {};
		this.forceGuidedExperienceInterval = {};
		this.endingAppleTVPlusExperienceInterval = {};

		this.loadPanel = this.loadPanel.bind(this);
		this.loadAssetComments = this.loadAssetComments.bind(this);
		this.createViewerComment = this.createViewerComment.bind(this);
		this.resetPromptToHomePage = this.resetPromptToHomePage.bind(this);
		this.handlePromptToHomePage = this.handlePromptToHomePage.bind(this);
		this.grabEnvironmentModalType = this.grabEnvironmentModalType.bind(this);

		this.handleGoogleAnalytics = this.handleGoogleAnalytics.bind(this);
		this.handleBillboardAsset = this.handleBillboardAsset.bind(this);
		this.handleQuestionIndexOverride = this.handleQuestionIndexOverride.bind(this);
		this.handleTimedExperience = this.handleTimedExperience.bind(this);
		this.handleCuratedPrompt = this.handleCuratedPrompt.bind(this);
		this.handleTargetAssetPrompt = this.handleTargetAssetPrompt.bind(this);

		this.beginGuidedExperience = this.beginGuidedExperience.bind(this);
		this.forceGuidedExperience = this.forceGuidedExperience.bind(this);
		this.handleTermination = this.handleTermination.bind(this);
		this.handleComplete = this.handleComplete.bind(this);
		this.handlePanelResponse = this.handlePanelResponse.bind(this);
		this.handleSVODPanelResponses = this.handleSVODPanelResponses.bind(this);
		this.handleProgressUpdate = this.handleProgressUpdate.bind(this);
		this.handleQsetIndex = this.handleQsetIndex.bind(this);
		this.handleAnalyticsEvent = this.handleAnalyticsEvent.bind(this);
		this.handleBadRespondents = this.handleBadRespondents.bind(this);
		this.handleOpenModal = this.handleOpenModal.bind(this);
		this.handleCloseModal = this.handleCloseModal.bind(this);
		this.handleClosePeacockWelcomeModal = this.handleClosePeacockWelcomeModal.bind(this);
		this.handleIncludedAppleTVPlusExperienceInterval = this.handleIncludedAppleTVPlusExperienceInterval.bind(this);
		this.closeFinalStepConfirmationModal = this.closeFinalStepConfirmationModal.bind(this);
		this.closeForceIncludedAppleTVPagePrompt = this.closeForceIncludedAppleTVPagePrompt.bind(this);
		this.closeTargetAssetPrompt = this.closeTargetAssetPrompt.bind(this);
		this.closeForceTargetAssetPrompt = this.closeForceTargetAssetPrompt.bind(this);

		this.resetCuratedPagePrompt = this.resetCuratedPagePrompt.bind(this);
		this.resetTargetAssetPrompt = this.resetTargetAssetPrompt.bind(this);
		this.resetWatchPagePrompt = this.resetWatchPagePrompt.bind(this);
		this.closeAppleTargetAssetPrompt = this.closeAppleTargetAssetPrompt.bind(this);
		this.closeForceAppleTargetAssetPrompt = this.closeForceAppleTargetAssetPrompt.bind(this);
		this.closeReturnToContentPrompt = this.closeReturnToContentPrompt.bind(this);
		this.closeTransactionPrompt = this.closeTransactionPrompt.bind(this);

		this.returnUpdatedGoodwill = this.returnUpdatedGoodwill.bind(this);
		this.returnQuestionMap = this.returnQuestionMap.bind(this);
		this.returnQuestionSetInit = this.returnQuestionSetInit.bind(this);

		this.isSurveyReady = this.isSurveyReady.bind(this);
		this.onReceiveEvent = this.onReceiveEvent.bind(this);

		this.handleUserActive = this.handleUserActive.bind(this);

		this.handleTrackerUpdate = this.handleTrackerUpdate.bind(this);
	}

	componentDidMount() {
		if (this.props.targetParams) {
			this.loadPanel(this.props.fetchedGroup, this.props.targetParams, this.props.currentUser);
		}
	}

	componentWillUnmount() {
		this.stopUserActiveTimer();
		this.setState({
			questionSetIndex: 0,
			questionIndex: 0,
			questionSetMap: {},
			questionMap: {},
			pathTracker: []
		});
	}

	startUserActiveTimer() {
		const userActiveTimer = setInterval(this.handleUserActive, 5000);
		this.setState({userActiveTimer: userActiveTimer});
	}

	stopUserActiveTimer() {
		const userActiveTimer = this.state.userActiveTimer;
		if (userActiveTimer) {
			clearInterval(userActiveTimer);
			this.setState({userActiveTimer: null});
		}
	}

	async handleUserActive() {
		const params = this.returnParams();
		const groupId = params.group_id;
		const panelSegmentIndex = params.panelSegmentIndex;
		const userId = this.props.currentUser.user_id;
		const userToken = auth.getToken();
		try {
			const userSubResult = await updateUserSubscription(userId, userToken, { group_id: groupId });
			if (userSubResult && !userSubResult.success) {
				Logger.log(this.constructor.name, "handleUserActive() eject user", userSubResult, userSubResult);
				const data = { message: { eventCall: 'UPDATE_USER_SUBSCRIPTION_ERROR', params: { groupId: groupId, panelSegmentIndex: panelSegmentIndex, userId: userId } } };
				this.handleAnalyticsEvent(data);
			}
			else {
				Logger.log(this.constructor.name, "handleUserActive() UPDATE_USER_SUBSCRIPTION", userSubResult);
			}
		}
		catch (error) {
			if (error && error.code === "user_id_incorrect") {
				Logger.error(this.constructor.name, "handleUserActive() updateUserSubscription user_id_incorrect", error);
				const groupInfo = {group_id: groupId, panel_segment: panelSegmentIndex};
				this.handleTermination(groupInfo, SCREEN_CODES.EJECT_CODE, "user_id_incorrect");
			}
			else {
				Logger.error(this.constructor.name, "handleUserActive()", "updateUserSubscription error", error);
				throw new Error(error);
			}
		}
	}

	// Pulls the environment class specific to the SVOD type (AppleTV+, Peacock, default)
	grabEnvironmentModalType() {
		switch (this.props.fetchedGroup.svod_env.environment_vendor) {
			case EnvType.APPLETV:
				return "svod-modal-appletv";
			case EnvType.PEACOCK:
				return "svod-modal-peacock";
			default:
				return "svod-modal";
		}
	}

	async loadPanel(group, targetParams, currentUser) {
		try {
			let psIndex = targetParams.panelSegmentIndex ?
				targetParams.panelSegmentIndex.toString()
				:
				targetParams.ps ?
					targetParams.ps
					:
					"0";

			let panelSegment = group && group.panel_segment && group.panel_segment[psIndex] ?
				group.panel_segment[psIndex]
				:
				null;
			let panel_id = panelSegment ? panelSegment.panel : null;
			let user_token = auth.getToken();
			const result = await getStudyPanel(panel_id, user_token);

			if (result) {
				Logger.log(this.constructor.name, "loadPanel() getStudyPanel result", result);
				let questionMap = this.returnQuestionMap(result);
				let { questionSetIndex, questionIndex } = this.returnQuestionSetInit(result);
				let questionSetMap = this.returnQuestionSetMap(result);
				let maxQsetIndex = this.returnMaxQsetIndex(result);

				let { assetsInfoMap, rowInfoMap, promosInfoMap, billboardAsset } = this.returnAssetsInfo(this.props.fetchedGroup);

				this.setState({
					assetsInfoMap,
					rowInfoMap,
					promosInfoMap,
					billboardAsset,
					fetchedPanel: result,
					questionMap,
					questionSetMap,
					questionSetIndex,
					questionIndex,
					maxQsetIndex
				}, () => {
					this.startUserActiveTimer();
					this.props.setFetchedPanel(result);
				});
			}
			else {
				this.setState({ loading: false });
				Logger.log(this.constructor.name, "loadPanel() No result");
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
				this.setState({ errors });
			}
		}
		catch (error) {
			this.setState({ loading: false });
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "loadPanel() error", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
			this.setState({ errors });
		}
	}

	async loadAssetComments(asset_id) {
		try {
			let user_token = auth.getToken();
			const result = await getAssetComments(asset_id, user_token);

			this.setState({ loading: true });

			if (result) {
				Logger.log(this.constructor.name, "loadAssetComments() result:", result);

				/* Google analytics event - API Call for Comments */
				let svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_COMMENTSDATA, '', '', false, false, true, false);
				svodStatus.gaTracker = this.props.tracker;
				svodStatus.state = this.state;
				svodStatus.label = 'success';
				this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

				this.setState({ loading: false, currentAssetComments: result.comments });
			}
			else {
				this.setState({ loading: false });
				Logger.log(this.constructor.name, "loadAssetComments() No result");
				let errors = { ...this.state.errors };
				errors.reason = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
				this.setState({ errors });
			}
		}
		catch (error) {
			this.setState({ loading: false });
			let errors = { ...this.state.errors };

			/* Google analytics event - API Call for Comments */
			let svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_COMMENTSDATA, '', '', false, false, true, false);
			svodStatus.gaTracker = this.props.tracker;
			svodStatus.state = this.state;
			svodStatus.label = 'fail';
			this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

			Logger.log(this.constructor.name, "loadAssetComments() error", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
			this.setState({ errors });
		}
	}

	async createViewerComment(commentData) {
		try {
			let { currentUser, fetchedGroup, targetParams } = this.props;
			let user_token = auth.getToken();

			let commentInfo = {
				group_id: fetchedGroup._id.valueOf(),
				research_env: fetchedGroup.research_env,
				panel_segment: targetParams.panelSegmentIndex,
				user_id: currentUser.user_id,
				asset_id: commentData.asset_id,
				text: commentData.text,
				timecode: commentData.timecode,
				username: commentData.username,
				rating: commentData.rating,
				profilePictureNumber: commentData.profilePictureNumber,
			};

			const result = await postAssetComment(commentInfo, user_token);
			if (result) {
				Logger.log(this.constructor.name, "createViewerComment() Viewer comment: SUCCESS", result);
				this.loadAssetComments(commentData.asset_id);
			}
			else {
				Logger.log(this.constructor.name, "createViewerComment() Viewer comment: FAILED - No result");
				this.setState({ loading: false });
				let errors = { ...this.state.errors };
				errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
				this.setState({ errors });
			}
		}
		catch (error) {
			this.setState({ loading: false });
			let errors = { ...this.state.errors };
			Logger.log(this.constructor.name, "createViewerComment() Viewer comment: ERROR", error);
			errors["status"] = this.props.intl.formatMessage(localeMessages.error_study_loading_info);
			this.setState({ errors });
		}
	}

	async notifyError(message) {
		// Logger.log(this.constructor.name, "notifyError()");
	}

	async handleTermination(group, screenCode, feedbackType, question, reason) {
		Logger.log(this.constructor.name, "handleTermination(): SCREEN:", screenCode, "FEEDBACK", feedbackType, "QID:", question.qid, "QTYPE:", question.type);

		let disableBadResponseTerminate = this.props.targetParams.br === '0';
		let submitTermination = screenCode !== SCREEN_CODES.BAD_RESPONDANT_CODE || (screenCode === SCREEN_CODES.BAD_RESPONDANT_CODE && !disableBadResponseTerminate);

		if (submitTermination) {
			let psIndex = this.props.targetParams.panelSegmentIndex ?
				this.props.targetParams.panelSegmentIndex.toString()
				:
				this.props.targetParams.ps ?
					this.props.targetParams.ps
					:
					"0";

			let user_token = auth.getToken();
			let url = settings.api_host + "/event/terminate";

			const terminateResponse = {
				user_token,
				group_id: group._id,
				panel_segment: psIndex,
				user_id: this.props.currentUser.user_id,
				screen_code: screenCode,
				reason: reason ? reason : 'unknown',
				screen_qid: question.qid
			};

			const isTester = TargetProcess.isTester(this.props.targetParams);

			if (isTester) { terminateResponse.test = this.props.targetParams.test; }

			axios.post(url, terminateResponse)
				.then(result => {
					Logger.log(this.constructor.name, "handleTermination()", url, result);
					if (screenCode === SCREEN_CODES.BAD_RESPONDANT_CODE
						|| screenCode === SCREEN_CODES.QUESTION_TERMINATE_CODE
						|| screenCode === SCREEN_CODES.EJECT_CODE
						|| screenCode === SCREEN_CODES.QUOTA_FULL_CODE
					) {
						let feedbackType = SCREEN_CODES.returnScreenCodeFeedback(screenCode);
						this.setState({ feedbackType });
					}
				})
				.catch((error) => {
					Logger.log(this.constructor.name, "handleTermination()", 'Reporting Termination FAILED', error);
					this.setState({ feedbackType: 'error', error: error });
				});
		}
	}

	async handleComplete(group, feedbackType) {
		// Logger.log(this.constructor.name, "handleComplete(): FEEDBACK", feedbackType);
		let psIndex = this.props.targetParams.panelSegmentIndex ?
			this.props.targetParams.panelSegmentIndex.toString()
			:
			this.props.targetParams.ps ?
				this.props.targetParams.ps
				:
				"0";

		let user_token = auth.getToken();
		// let url = settings.api_host + "/event/complete"; // pull complete api endpoint

		const completeResponse = {
			user_token,
			group_id: group._id,
			panel_segment: psIndex,
			user_id: this.props.currentUser.user_id,
			complete: 1
		};

		const isTester = TargetProcess.isTester(this.props.targetParams);

		if (isTester) {
			completeResponse.tester = this.props.targetParams.test;
		}

		// Logger.log(this.constructor.name, "handleComplete() COMPLETE RESPONSE:", completeResponse);
		this.setState({ feedbackType: 'thankyou' });
	}

	async handleSVODPanelResponses(hiddenAnswerPhrase, submittedSVODKey, identifier, svodQuestionType, submitCount) {
		const { fetchedGroup, fetchedPanel, targetParams, currentUser } = this.props;
		const submittedSVODQuestions = { ...this.state.submittedSVODQuestions };
		const user_token = auth.getToken();
		let updatedSubmitCount = !submitCount ? 0 : submitCount;

		if (!submittedSVODQuestions[submittedSVODKey]) {
			try {
				const svod = fetchedGroup && fetchedGroup.svod_env;
				const results = await createSVODResponses(fetchedGroup, fetchedPanel, identifier, svod, targetParams.panelSegmentIndex, hiddenAnswerPhrase, svodQuestionType, currentUser, user_token);
				if (results) {
					Logger.log(this.constructor.name, "handleSVODPanelResponses() result", results);
					submittedSVODQuestions[submittedSVODKey] = true;
					let answerTracker = cloneDeep(this.state.answerTracker);
					let pathTracker = cloneDeep(this.state.pathTracker);
					const { answerIds, pathIds } = returnAnswerAndPathIdsFromSurvey(fetchedPanel, results);

					if (answerIds && answerIds.length) answerTracker = answerTracker.concat(answerIds);
					if (pathIds && pathIds.length) pathTracker = pathTracker.concat(pathIds);
					this.setState({ submittedSVODQuestions, answerTracker, pathTracker });
				}
				else {
					Logger.log(this.constructor.name, "Failed to post panel response. Submitting again - count", updatedSubmitCount + 1);

					if (updatedSubmitCount < PANEL_RESPONSE_SUBMIT_LIMIT) {
						updatedSubmitCount++;
						this.handleSVODPanelResponses(hiddenAnswerPhrase, identifier, submittedSVODKey, svodQuestionType, updatedSubmitCount);
					}
					else if (updatedSubmitCount >= PANEL_RESPONSE_SUBMIT_LIMIT) {
						this.handleTermination(fetchedGroup, SCREEN_CODES.BAD_RESPONDANT_CODE, 'dataquality', {}, SCREEN_REASONS.STALLED);
					}
				}
			}
			catch (error) {
				Logger.log(this.constructor.name, "Panel Response Failed", error);

				if (updatedSubmitCount < PANEL_RESPONSE_SUBMIT_LIMIT) {
					updatedSubmitCount++;
					this.handleSVODPanelResponses(hiddenAnswerPhrase, identifier, submittedSVODKey, svodQuestionType, updatedSubmitCount);
				}
				else if (updatedSubmitCount >= PANEL_RESPONSE_SUBMIT_LIMIT) {
					this.handleTermination(fetchedGroup, SCREEN_CODES.BAD_RESPONDANT_CODE, 'dataquality', {}, SCREEN_REASONS.STALLED);
				}
			}
		}
	}

	async handlePanelResponse(selectedAnswers, selectedPaths, question, screenCode, questionValidation, positions, language, submitCount) {
		if (question.type !== "messageCard" && question.type !== "activityPrompt") {
			let user_token = auth.getToken();
			const params = this.returnParams();
			const qset_asset = this.state.qset_asset;
			submitCount = !submitCount ? 0 : submitCount;

			let aid = "";
			if (selectedAnswers &&
				Array.isArray(selectedAnswers) &&
				selectedAnswers.length &&
				question.type !== "openEnded"
			) {
				selectedAnswers.forEach((answer_id, ansIndex) => {
					aid += (ansIndex === 0 ? "" : "+") + answer_id;
				});
			}
			else if (selectedAnswers && question.type === "openEnded") { aid = selectedAnswers; }
			else { aid = '0'; }

			let position = '';
			if (positions && positions.length) {
				positions.forEach((positionValue, index) => {
					position += (index === 0 ? "" : "+") + positionValue;
				});
			}
			else {
				position = '-1';
			}

			Logger.log(this.constructor.name, "handlePanelResponse() QID:", question.qid, "QTYPE:", question.type, "SCREEN:", screenCode, "ANS:", aid, "PATHS:", selectedPaths);

			let panelResponse = {
				group_id: params.group_id,
				panel_segment: params.panelSegmentIndex,
				panel_id: this.props.fetchedPanel._id,
				qid: question.qid,
				aid: aid,
				position: position,
				duration: questionValidation.duration,
				feedback_pro: this.props.currentUser.user_profile_privacy.feedback_pro,
				user_id: this.props.currentUser.user_id,
				timecode: question.hint_time
			};

			if (qset_asset) panelResponse.asset_id = qset_asset;
			if (language) { panelResponse.language = language; }

			Logger.log(this.constructor.name, "handlePanelResponse()", 'Submitting panel response', panelResponse);

			if (PANEL_HELPERS.validateQuestionSubmission(question, panelResponse)) {
				try {
					const result = await createPanelResponse(panelResponse, user_token);
					if (result) {
						Logger.log(this.constructor.name, "handlePanelResponse() result", result);
					}
					else {
						Logger.log(this.constructor.name, "Failed to post panel response. Submitting again - count", submitCount + 1);

						if (submitCount < PANEL_RESPONSE_SUBMIT_LIMIT) {
							submitCount++;
							this.handlePanelResponse(selectedAnswers, selectedPaths, question, screenCode, questionValidation, positions, language, submitCount);
						}
						else if (submitCount >= PANEL_RESPONSE_SUBMIT_LIMIT) {
							this.handleTermination(this.props.fetchedGroup, SCREEN_CODES.BAD_RESPONDANT_CODE, 'dataquality', question, SCREEN_REASONS.STALLED);
						}
					}
				}
				catch (error) {
					Logger.log(this.constructor.name, "Panel Response Failed", error);

					if (submitCount < PANEL_RESPONSE_SUBMIT_LIMIT) {
						submitCount++;
						this.handlePanelResponse(selectedAnswers, selectedPaths, question, screenCode, questionValidation, positions, language, submitCount);
					}
					else if (submitCount >= PANEL_RESPONSE_SUBMIT_LIMIT) {
						this.handleTermination(this.props.fetchedGroup, SCREEN_CODES.BAD_RESPONDANT_CODE, 'dataquality', question, SCREEN_REASONS.STALLED);
					}
				}
			}
			else {
				Logger.log(this.constructor.name, "handlePanelResponse() - skipping, no avaliable answer", question.type, "Continuing to next question");
			}
		}
		else {
			Logger.log(this.constructor.name, "handlePanelResponse() -", question.type, "Continuing to next question");
		}
	}

	async handleEnvironmentResponse(environment_response) {
		const url = `${settings.api_host}/event/environment`;
		const params = this.returnParams();
		const user_token = auth.getToken();
		let updatedEnvironmentResponse = this.returnResponseWithDates(environment_response);
		updatedEnvironmentResponse.promo_activity = this.state.promosWatched;
		updatedEnvironmentResponse.modal_time = this.state.totalModalTime;

		let environmentResponse = {
			user_token,
			group_id: params.group_id,
			panel_segment: params.panelSegmentIndex,
			panel_id: this.props.fetchedPanel._id,
			user_id: this.props.currentUser.user_id,
			environment_response: updatedEnvironmentResponse
		};
		if (updatedEnvironmentResponse._id) environmentResponse._id = updatedEnvironmentResponse._id;

		Logger.log(this.constructor.name, "handleEnvironmentResponse():", 'Submitting environment response', environmentResponse);

		try {
			const response = await axios({
				method: 'post',
				url,
				data: environmentResponse,
				config: { headers: { 'Content-Type': 'multipart/form-data' } }
			});

			let status = "";
			Logger.log(this.constructor.name, "handleEnvironmentResponse():", url, response);

			switch (response.status) {
				case (200): {
					status = "success";
					this.setState({ environmentResponse: response.data.result });
					break;
				}
				default: {
					status = "fail";
					break;
				}
			}
			Logger.log(this.constructor.name, "handleEnvironmentResponse()", status);
		}
		catch (error) {
			let reason = error.reason ? error.reason : error.toString();
			Logger.log(this.constructor.name, "handleEnvironmentResponse(): Environment Response Failed", error, "REASON:", reason);
		}
	}

	handleGoogleAnalytics(userInput, galabel) {
		const { globalAnalyticsAdapter } = this.props;

		let svodStatus = new SVODStatus(userInput, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.state = this.state;
		svodStatus.label = galabel;
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

		globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);
	}

	// method called to receive events from SVOD
	onReceiveEvent(event) {
		Logger.log(this.constructor.name, "onReceiveEvent() SVOD EVENT", event);

		// potential setup for events passed from svod
		const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
		const eventType = data.event_type || data.event; // trigger event
		const { fetchedPanel, fetchedGroup } = this.props;
		const { svod_env } = fetchedGroup;
		let state = { ...this.state };

		let {
			assetsInfoMap,
			rowInfoMap,
			midRowInfoMap,
			myListInfoMap,
			promosInfoMap,
			environmentResponse,
			modalTitle,
			modalMessage,
			modalType,
			modalBackgroundCover,
			startTimeInSVOD,
			timeInSVOD,

			questionSetIndex,
			questionIndex,
			pathTracker,
			viewCount,
			commentCount,
			fullscreensWatched,
			trailersWatched,
			promosWatched,
			currentTrailerAsset,
			questionSetsDisplayed,

			watchingFullScreen,
			qset_asset,
			targetAssetIndex
		} = state;

		const isAppleTVGuided = svod_env && svod_env.guided_experience && svod_env.guided_experience.included_appletv_page;
		const isShowPageTargetGuided = svod_env && svod_env.guided_experience && svod_env.guided_experience.show_page_targets;

		const closeAllTrailers = (trailersWatched, data) => {
			for (let asset_id in trailersWatched) {
				if (!trailersWatched[asset_id].endTime) {
					trailersWatched[asset_id].endTime = data.time;
					let { startTime, endTime } = trailersWatched[asset_id];
					let assetDuration = assetsInfoMap[asset_id] ? assetsInfoMap[asset_id].duration : 0;
					if (isNumber(startTime) && isNumber(endTime)) {
						trailersWatched[asset_id].completion = assetDuration
							? Math.round((((endTime - startTime) / 1000) / assetDuration) * 100)
							: 0;
					}
				}
			}
			return trailersWatched;
		};

		const returnWatchComplete = (duration, startTime, endTime) => {
			let completeRate = 0;
			if (isNumber(startTime) && isNumber(endTime)) {
				completeRate = duration ? (Math.round(((endTime - startTime) / 1000)) / duration) * 100 : 0;
				completeRate = completeRate >= 100 ? 100 : completeRate;
			}
			return completeRate;
		};

		const returnTimeInViewObject = (infoMap, dataObj) => {
			let isStartInteraction = dataObj.action === "start_time";
			let isEndInteraction = dataObj.action === "end_time";

			infoMap[dataObj.asset_id].init_start_time = isStartInteraction ?
				dataObj.time
				:
				infoMap[dataObj.asset_id].init_start_time;

			infoMap[dataObj.asset_id].init_end_time = isEndInteraction ?
				dataObj.time
				:
				infoMap[dataObj.asset_id].init_end_time;

			if (isEndInteraction) {
				let startTime = infoMap[dataObj.asset_id].init_start_time;
				let endTime = infoMap[dataObj.asset_id].init_end_time;

				infoMap[dataObj.asset_id].time_interacted_with.push({
					start_time: startTime,
					end_time: endTime
				});

				if (isNumber(startTime) && isNumber(endTime)) {
					infoMap[dataObj.asset_id].time_in_view.push((endTime - startTime) / 1000);
				}

				delete infoMap[dataObj.asset_id].init_start_time;
				delete infoMap[dataObj.asset_id].init_end_time;
			}

			return infoMap;
		};

		const returnUpdatedAssetInteractions = (
			environmentResponse,
			trailersWatched,
			currentTrailerAsset,
			assetsInfoMap,
			rowInfoMap,
			myListInfoMap,
			data,
			startTimeInSVOD,
			promosInfoMap,
		) => {
			environmentResponse.asset_activity = [];
			environmentResponse.row_activity = [];
			environmentResponse.mid_row_activity = {};
			environmentResponse.my_list_activity = {};

			environmentResponse.start_time_in_env = startTimeInSVOD;
			environmentResponse.end_time_in_env = Date.now();
			environmentResponse.total_time_in_env = (environmentResponse.end_time_in_env - environmentResponse.start_time_in_env) / 1000;
			environmentResponse.my_list_activity = myListInfoMap;

			// closing trailers
			trailersWatched = closeAllTrailers(trailersWatched, data);
			for (let asset_id in trailersWatched) {
				assetsInfoMap[asset_id].show_details.trailer_completion = assetsInfoMap[asset_id].show_details.trailer_completion < trailersWatched[asset_id].completion || !assetsInfoMap[asset_id].show_details.trailer_completion ?
					trailersWatched[asset_id].completion
					:
					assetsInfoMap[asset_id].show_details.trailer_completion;

				assetsInfoMap[asset_id].show_details.time_interacted_with.push({
					start_time: trailersWatched[asset_id].startTime,
					end_time: trailersWatched[asset_id].endTime
				});
			}
			currentTrailerAsset = null;

			for (let asset_id in assetsInfoMap) {
				let assetObject = assetsInfoMap[asset_id];
				let totalTimeOnAsset = 0;

				if (assetObject.fullscreen.time_interacted_with.length) {
					assetObject.fullscreen.time_interacted_with.forEach((interaction) => {
						if (interaction.start_time
							&& interaction.end_time
							&& isNumber(interaction.start_time)
							&& isNumber(interaction.end_time)
						) {
							totalTimeOnAsset += ((interaction.end_time - interaction.start_time) / 1000);
						}
					});
				}

				if (assetObject.poster.time_interacted_with.length) {
					assetObject.poster.time_interacted_with.forEach((interaction) => {
						if (interaction.start_time
							&& interaction.end_time
							&& isNumber(interaction.start_time)
							&& isNumber(interaction.end_time)
						) {
							totalTimeOnAsset += ((interaction.end_time - interaction.start_time) / 1000);
						}
					});
				}

				if (assetObject.tile.time_interacted_with.length) {
					assetObject.tile.time_interacted_with.forEach((interaction) => {
						if (interaction.start_time
							&& interaction.end_time
							&& isNumber(interaction.start_time)
							&& isNumber(interaction.end_time)
						) {
							totalTimeOnAsset += ((interaction.end_time - interaction.start_time) / 1000);
						}
					});
				}

				if (assetObject.show_details.time_interacted_with.length) {
					assetObject.show_details.time_interacted_with.forEach((interaction) => {
						if (interaction.start_time
							&& interaction.end_time
							&& isNumber(interaction.start_time)
							&& isNumber(interaction.end_time)
						) {
							totalTimeOnAsset += ((interaction.end_time - interaction.start_time) / 1000);
						}
					});
				}

				if (assetObject.count) {
					assetsInfoMap[asset_id].total_time_on_tile = totalTimeOnAsset;
					environmentResponse.asset_activity.push(assetsInfoMap[asset_id]);
				}
			}

			for (let row_id in rowInfoMap) {
				let totalTimeOnRow = 0;
				if (rowInfoMap[row_id].time_interacted_with.length) {
					rowInfoMap[row_id].time_interacted_with.forEach((interaction) => {
						if (interaction.start_time
							&& interaction.end_time
							&& isNumber(interaction.start_time)
							&& isNumber(interaction.end_time)
						) {
							totalTimeOnRow += ((interaction.end_time - interaction.start_time) / 1000);
						}
						else if (interaction.start_time
							&& !interaction.end_time
							&& environmentResponse.end_time_in_env
							&& isNumber(environmentResponse.end_time_in_env)
							&& isNumber(interaction.start_time)
						) {
							totalTimeOnRow += ((environmentResponse.end_time_in_env - interaction.start_time) / 1000);
						}
					});
				}

				if (rowInfoMap[row_id].init_start_time
					&& !rowInfoMap[row_id].init_end_time
					&& environmentResponse.end_time_in_env
					&& isNumber(rowInfoMap[row_id].init_start_time)
					&& isNumber(environmentResponse.end_time_in_env)
				) {
					rowInfoMap[row_id].time_in_view.push((environmentResponse.end_time_in_env - rowInfoMap[row_id].init_start_time) / 1000);

					delete rowInfoMap[row_id].init_start_time;
					delete rowInfoMap[row_id].init_end_time;
				}

				rowInfoMap[row_id].total_time_on_row = totalTimeOnRow;
				environmentResponse.row_activity.push(rowInfoMap[row_id]);
			}

			for (let asset_id in promosInfoMap) {
				let assetObject = promosInfoMap[asset_id];

				if (assetObject.count) {
					environmentResponse.asset_activity.push(promosInfoMap[asset_id]);
				}
			}

			if (environmentResponse.exit_svod) {
				environmentResponse.row_activity = environmentResponse.row_activity.filter((row) => {
					return row.time_in_view && row.time_in_view.length > 0;
				});
			}

			return {
				environmentResponse,
				trailersWatched,
				currentTrailerAsset,
				assetsInfoMap,
				rowInfoMap,
				myListInfoMap
			};
		};

		const updatePromosWatchedTracking = (data) => {
			for (let promo_id in promosWatched) {
				if (!promosWatched[promo_id].endTime) {
					promosWatched[promo_id].endTime = data.time;
					let { startTime, endTime } = promosWatched[promo_id];
					let assetDuration = promosInfoMap[promo_id] ? promosInfoMap[promo_id].duration : 0;

					promosWatched[promo_id].completion = returnWatchComplete(assetDuration, startTime, endTime);
				}
			}

			promosInfoMap[data.promo_id].fullscreen.completion = promosInfoMap[data.promo_id].fullscreen.completion <= promosWatched[data.promo_id].completion || !promosInfoMap[data.promo_id].fullscreen.completion ? promosWatched[data.promo_id].completion : promosInfoMap[data.promo_id].fullscreen.completion;
			promosInfoMap[data.promo_id].type = promosWatched[data.promo_id].type;
			promosWatched[data.promo_id].end_timecode = data.timecode;

			promosInfoMap[data.promo_id].fullscreen.time_interacted_with.push({
				start_time: promosWatched[data.promo_id].startTime,
				end_time: promosWatched[data.promo_id].endTime,
				exit_timecode: data.timecode
			});

			if (promosWatched[data.promo_id] &&
				promosWatched[data.promo_id].completion
			) {
				promosInfoMap[data.promo_id].count++;
			}

			pathTracker = this.handlePathTrackerUpdate(fetchedPanel, data, 'start-watch', pathTracker, promosWatched, environmentResponse.button_click_activity, 'promo_id');
			pathTracker = this.handlePathTrackerUpdate(fetchedPanel, data, 'watched', pathTracker, promosWatched, environmentResponse.button_click_activity, 'promo_id');
			pathTracker = this.handlePathTrackerUpdate(fetchedPanel, data, 'not-watched', pathTracker, promosWatched, environmentResponse.button_click_activity, 'promo_id');
			pathTracker = this.handlePathTrackerUpdate(fetchedPanel, data, 'skip-clicked', pathTracker, promosInfoMap, environmentResponse.button_click_activity, 'promo_id');
			pathTracker = this.handlePathTrackerUpdate(fetchedPanel, data, 'skip-not-clicked', pathTracker, promosInfoMap, environmentResponse.button_click_activity, 'promo_id');
		};

		const updateAssetsWatchedTracking = (data) => {
			for (let asset_id in fullscreensWatched) {
				if (!fullscreensWatched[asset_id].endTime) {
					fullscreensWatched[asset_id].endTime = data.time;
					let { startTime, endTime } = fullscreensWatched[asset_id];
					let assetDuration = assetsInfoMap[asset_id] ? assetsInfoMap[asset_id].duration : 0;

					fullscreensWatched[asset_id].completion = returnWatchComplete(assetDuration, startTime, endTime);
				}
			}

			assetsInfoMap[data.asset_id].fullscreen.completion = assetsInfoMap[data.asset_id].fullscreen.completion <= fullscreensWatched[data.asset_id].completion || !assetsInfoMap[data.asset_id].fullscreen.completion ? fullscreensWatched[data.asset_id].completion : assetsInfoMap[data.asset_id].fullscreen.completion;
			assetsInfoMap[data.asset_id].type = fullscreensWatched[data.asset_id].type;

			assetsInfoMap[data.asset_id].fullscreen.time_interacted_with.push({
				start_time: fullscreensWatched[data.asset_id].startTime,
				end_time: fullscreensWatched[data.asset_id].endTime,
				exit_timecode: data.timecode,
			});

			let timeEngaged = (fullscreensWatched[data.asset_id].endTime - fullscreensWatched[data.asset_id].startTime) / 1000;
			if (fullscreensWatched[data.asset_id] &&
				fullscreensWatched[data.asset_id].completion &&
				timeEngaged >= MINIMUM_TIME_ENGAGED
			) {
				assetsInfoMap[data.asset_id].count++;
			}

			pathTracker = this.handlePathTrackerUpdate(fetchedPanel, data, 'start-watch', pathTracker, fullscreensWatched);
			pathTracker = this.handlePathTrackerUpdate(fetchedPanel, data, 'watched', pathTracker, fullscreensWatched);
			pathTracker = this.handlePathTrackerUpdate(fetchedPanel, data, 'not-watched', pathTracker, fullscreensWatched);
			pathTracker = this.handlePathTrackerUpdate(fetchedPanel, data, 'skip-clicked', pathTracker, fullscreensWatched, environmentResponse.button_click_activity);
			pathTracker = this.handlePathTrackerUpdate(fetchedPanel, data, 'skip-not-clicked', pathTracker, fullscreensWatched, environmentResponse.button_click_activity);

			currentTrailerAsset = null;
			watchingFullScreen = false;
		};

		// watched / didn't watch / started to watch  / commented on 
		let enableExitSurvey = false;
		let enableModalPrompt = false;
		let displayQuestionSet = null;
		let directExitToSurvey = false;
		switch (eventType) {
			case "page_enter": { // GA
				let { currentPage } = state;
				currentPage[data.page_location] = {
					page_location: data.page_location,
					page_details: {
						asset_id: data.asset_id,
						asset_name: data.asset_name,
					},
					enter_time: data.time,
					exit_time: null,
				};

				let gaLabel = data.page_location + (data.name ? '-' + data.name : '');
				this.handleGoogleAnalytics(SVODStatusEvent.SVODSESSION_ENTERPAGE, gaLabel);

				this.onReceiveEvent({
					data: {
						event_type: "update_environment_response",
						type: "page_enter",
						time: Date.now()
					}
				});
				this.setState({ currentPage });
				break;
			}
			case "page_exit": { // GA
				let { currentPage } = state;
				if (currentPage[data.page_location]) {
					currentPage[data.page_location].exit_time = data.time;
					if (environmentResponse.page_activity
						&& !environmentResponse.page_activity[data.page_location]
					) {
						environmentResponse.page_activity[data.page_location] = [];
					}
					environmentResponse.page_activity[data.page_location].push(currentPage[data.page_location]);
				}

				let gaLabel = data.page_location + (data.name ? '-' + data.name : '');
				this.handleGoogleAnalytics(SVODStatusEvent.SVODSESSION_EXITPAGE, gaLabel);
				this.setState({ environmentResponse });
				break;
			}
			case "modal_open": { // GA
				let { currentModal } = state;
				currentModal[data.page_location] = {
					page_location: data.page_location,
					name: data.modal_name,
					enter_time: data.time,
					exit_time: null,
				};

				let gaLabel = (data.page_location + '-' + data.modal_name).replaceAll(/_/g, ' ');
				this.handleGoogleAnalytics(SVODStatusEvent.SVODSESSION_INFOMODAL, gaLabel);
				this.setState({ currentModal });
				break;
			}
			case "modal_close": {
				let { currentModal } = state;
				if (currentModal[data.page_location]) {
					currentModal[data.page_location].exit_time = data.time;
					if (environmentResponse.modal_activity
						&& !environmentResponse.modal_activity[data.page_location]
					) {
						environmentResponse.modal_activity[data.page_location] = [];
					}
					environmentResponse.modal_activity[data.page_location].push(currentModal[data.page_location]);
				}

				this.setState({ environmentResponse });
				break;
			}
			case "modal_button_click": {
				environmentResponse.modal_button_click_activity.push(data);
				break;
			}
			case "thumbnail_click": {
				environmentResponse.thumbnail_click_activity.push(data);
				break;
			}
			case "billboard_click": {
				environmentResponse.billboard_click_activity.push(data);
				break;
			}
			case "highlight_click": {
				environmentResponse.highlight_click_activity.push(data);
				break;
			}
			case "player_activity": {
				environmentResponse.player_activity.push(data);
				break;
			}
			case "button_click":
			case "asset_fullscreen_playback":
			case "asset_fullscreen_playback_from_billboard": { // GA
				if (eventType === 'button_click') {
					environmentResponse.button_click_activity.push(data);
				}

				if ((eventType === 'button_click' && data.type === 'skip_click')) {
					updatePromosWatchedTracking(data);
				}

				if ((eventType === 'button_click' && data.type === 'watch_episode_click')
					|| (eventType === 'asset_fullscreen_playback' || eventType === 'asset_fullscreen_playback_from_billboard')
				) {
					if (!fullscreensWatched[data.asset_id]) {
						let assetDuration = assetsInfoMap[data.asset_id] ? assetsInfoMap[data.asset_id].duration : 0;
						fullscreensWatched[data.asset_id] = {
							startTime: data.time,
							endTime: null,
							duration: assetDuration,
							completion: null,
							views: 1,
							type: data.type
						};
					}
					else {
						fullscreensWatched[data.asset_id].views++;
						fullscreensWatched[data.asset_id].startTime = data.time;
						fullscreensWatched[data.asset_id].endTime = null;
					}

					// closing trailers
					for (let asset_id in trailersWatched) {
						if (!trailersWatched[asset_id].endTime) {
							trailersWatched[asset_id].endTime = data.time;
							let { startTime, endTime } = trailersWatched[asset_id];
							let assetDuration = assetsInfoMap[asset_id] ? assetsInfoMap[asset_id].duration : 0;
							trailersWatched[asset_id].completion = returnWatchComplete(assetDuration, startTime, endTime);

							assetsInfoMap[asset_id].show_details.trailer_completion = assetsInfoMap[asset_id].show_details.trailer_completion < trailersWatched[asset_id].completion || !assetsInfoMap[asset_id].show_details.trailer_completion ?
								trailersWatched[asset_id].completion
								:
								assetsInfoMap[asset_id].show_details.trailer_completion;

							assetsInfoMap[asset_id].show_details.time_interacted_with.push({
								start_time: trailersWatched[asset_id].startTime,
								end_time: trailersWatched[asset_id].endTime
							});
						}
					}

					let interactionType = data.type === "asset_details_dropdown" ?
						'show_details'
						:
						(data.type === "poster" ? "poster" : "tile");

					Logger.log(this.constructor.name, "onReceiveEvent() ASSET:", assetsInfoMap[data.asset_id] ? assetsInfoMap[data.asset_id].name : 'NOT FOUND');
					if (interactionType && assetsInfoMap[data.asset_id]) {
						assetsInfoMap[data.asset_id][interactionType].play = true;
					}

					viewCount++;
					// assetsInfoMap[data.asset_id].count++;
					currentTrailerAsset = null;
					watchingFullScreen = true;

					let gaLabel = 'watchasset-' + data.asset_id;
					this.handleGoogleAnalytics(SVODStatusEvent.SVODSESSION_WATCHASSET, gaLabel);
				}

				break;
			}
			case "close_asset_fullscreen_playback": {
				updateAssetsWatchedTracking(data);
				break;
			}
			case "promo_playback": {
				if (!promosWatched[data.promo_id]) {
					let assetDuration = promosInfoMap[data.promo_id] ? promosInfoMap[data.promo_id].duration : 0;
					promosWatched[data.promo_id] = {
						startTime: data.time,
						endTime: null,
						duration: assetDuration,
						completion: null,
						views: 1,
						type: data.type
					};
				}
				else {
					promosWatched[data.promo_id].views++;
					promosWatched[data.promo_id].startTime = data.time;
					promosWatched[data.promo_id].endTime = null;
				}
				break;
			}
			case "complete_promo_playback": {
				updatePromosWatchedTracking(data);
				break;
			}
			case "update_asset_watch_progress": {
				if (!environmentResponse.asset_watch_progress[data.asset_id]) {
					environmentResponse.asset_watch_progress[data.asset_id] = {
						videoDuration: data.video.video.duration,
						secondsWatched: data.current_time,
						completionPercentage: 0,
						time: data.time,
						asset_name: data.video.name,
						asset_id: data.video._id,
					};
				}
				else {
					environmentResponse.asset_watch_progress[data.asset_id].secondsWatched = environmentResponse.asset_watch_progress[data.asset_id].secondsWatched > data.current_time
						? environmentResponse.asset_watch_progress[data.asset_id].secondsWatched
						: data.current_time;
					environmentResponse.asset_watch_progress[data.asset_id].time = environmentResponse.asset_watch_progress[data.asset_id].time > data.time
						? environmentResponse.asset_watch_progress[data.asset_id].time
						: data.time;
				}

				let { videoDuration, secondsWatched } = environmentResponse.asset_watch_progress[data.asset_id];
				environmentResponse.asset_watch_progress[data.asset_id].completionPercentage = secondsWatched / videoDuration * 100;

				this.onReceiveEvent({ data: { event_type: "update_environment_response", time: Date.now() } });
				break;
			}
			case "update_environment_response": {
				let updatedAssetInteractions = returnUpdatedAssetInteractions(
					environmentResponse,
					trailersWatched,
					currentTrailerAsset,
					assetsInfoMap,
					rowInfoMap,
					myListInfoMap,
					data,
					startTimeInSVOD,
					promosInfoMap,
				);

				environmentResponse = updatedAssetInteractions.environmentResponse;
				trailersWatched = updatedAssetInteractions.trailersWatched;
				currentTrailerAsset = updatedAssetInteractions.currentTrailerAsset;
				assetsInfoMap = updatedAssetInteractions.assetsInfoMap;
				rowInfoMap = updatedAssetInteractions.rowInfoMap;
				myListInfoMap = updatedAssetInteractions.myListInfoMap;

				this.handleEnvironmentResponse(environmentResponse);
				break;
			}
			case "time_interacted_with": {
				let asset_id = data.asset_id;
				let startTime = data.start_time;
				let endTime = data.end_time;
				let dataType = data.type;

				if ((dataType === 'tile' || dataType === 'poster') &&
					startTime &&
					endTime &&
					assetsInfoMap[asset_id]
				) {
					let assetDuration = assetsInfoMap[asset_id] ? assetsInfoMap[asset_id].duration : 0;
					assetsInfoMap[asset_id][dataType].time_interacted_with.push({
						start_time: startTime,
						end_time: endTime
					});
					assetsInfoMap[asset_id][dataType].trailer_completion = returnWatchComplete(assetDuration, startTime, endTime);
					assetsInfoMap[asset_id].count++;
				}
				else if (dataType === 'row' &&
					startTime &&
					endTime &&
					rowInfoMap[asset_id]
				) {
					Logger.log(this.constructor.name, "time_interacted_with: SVOD EVENT", event);
					rowInfoMap[asset_id].time_interacted_with.push({
						start_time: startTime,
						end_time: endTime
					});
				}
				else if (dataType === "asset_details_dropdown" &&
					data.action === "switched_dropdown" &&
					assetsInfoMap[data.asset_id]
				) {
					trailersWatched[data.asset_id].endTime = data.time;
					let { startTime, endTime } = trailersWatched[data.asset_id];

					let assetDuration = assetsInfoMap[data.asset_id] ? assetsInfoMap[data.asset_id].duration : 0;
					trailersWatched[data.asset_id].completion = returnWatchComplete(assetDuration, startTime, endTime);

					assetsInfoMap[data.asset_id]['show_details'].trailer_completion = assetsInfoMap[data.asset_id]['show_details'].trailer_completion < trailersWatched[data.asset_id].completion || !assetsInfoMap[data.asset_id]['show_details'].trailer_completion ?
						trailersWatched[data.asset_id].completion
						:
						assetsInfoMap[data.asset_id]['show_details'].trailer_completion;

					assetsInfoMap[data.asset_id]['show_details'].time_interacted_with.push({
						start_time: startTime,
						end_time: endTime
					});
				}
				else if (dataType === 'watchlist') { // Routing to My List page
					if (!myListInfoMap.watchlist_count) myListInfoMap.watchlist_count = 0;
					if (!myListInfoMap.time_interacted_with) myListInfoMap.time_interacted_with = [];
					myListInfoMap.watchlist_count++;

					if (data.action === 'start_time') {
						myListInfoMap.init_start_time = data.time;
					}
					else if (data.action === 'end_time') {
						myListInfoMap.init_end_time = data.time;
						myListInfoMap.time_interacted_with.push({
							start_time: myListInfoMap.init_start_time,
							end_time: myListInfoMap.init_end_time
						});
						delete myListInfoMap.init_start_time;
						delete myListInfoMap.init_end_time;
					}
				}
				break;
			}
			case "watchlist": { // Adding an asset to My List
				let asset_id = data.asset_id;
				let interactionType = data.type === "tile" ?
					'tile'
					:
					(data.type === "asset_details_dropdown" ?
						'show_details'
						:
						data.type === "poster" ? "poster" : null
					);
				let action = data.action;
				if (interactionType && action === "added_to_watchlist") {
					assetsInfoMap[asset_id][interactionType].add_to_list = true;
					assetsInfoMap[asset_id].added_to_wishlist = true;
				}
				else if (action === "removed_from_watchlist") {
					assetsInfoMap[asset_id]['tile'].add_to_list = false;
					assetsInfoMap[asset_id]['poster'].add_to_list = false;
					assetsInfoMap[asset_id]['show_details'].add_to_list = false;
					assetsInfoMap[asset_id].added_to_wishlist = false;
				}
				assetsInfoMap[asset_id].count++;
				break;
			}
			case "rating": {
				let asset_id = data.asset_id;
				let interactionType = data.type === "tile" ?
					'tile'
					:
					(data.type === "asset_details_dropdown" ?
						'show_details'
						:
						data.type === "poster" ? "poster" : null
					);
				let rating = data.action === 'like' ? 1 : 0;
				if (interactionType) assetsInfoMap[asset_id][interactionType].rating = rating;
				assetsInfoMap[asset_id].rating = rating;
				assetsInfoMap[asset_id].count++;
				break;
			}
			case "commented": {
				commentCount++;
				trailersWatched = closeAllTrailers(trailersWatched, data);
				pathTracker = this.handlePathTrackerUpdate(fetchedPanel, data, 'commented', pathTracker);
				assetsInfoMap[data.asset_id].show_details.commented = true;
				assetsInfoMap[data.asset_id].show_details.rating = data.comment_data.rating;
				assetsInfoMap[data.asset_id].rating = data.comment_data.rating;
				assetsInfoMap[data.asset_id].count++;
				break;
			}
			case "opened_dropdown":
			case "opened_billboard_details": {
				if (!trailersWatched[data.asset_id] ||
					!currentTrailerAsset ||
					(currentTrailerAsset &&
						trailersWatched[currentTrailerAsset] &&
						currentTrailerAsset !== data.asset_id)
				) {
					let assetDuration = assetsInfoMap[data.asset_id] ? assetsInfoMap[data.asset_id].duration : 0;
					if (!trailersWatched[data.asset_id]) {
						trailersWatched[data.asset_id] = {
							startTime: data.time,
							endTime: null,
							duration: assetDuration,
							completion: null,
							views: 1,
							type: data.type
						};
					}
					else {
						trailersWatched[data.asset_id].views++;
						trailersWatched[data.asset_id].startTime = data.time;
						trailersWatched[data.asset_id].endTime = null;
					}
				}

				viewCount++;
				currentTrailerAsset = data.asset_id;
				assetsInfoMap[data.asset_id].count++;
				pathTracker = this.handlePathTrackerUpdate(fetchedPanel, data, 'start-watch', pathTracker);
				break;
			}
			case "scrolled_to_bottom": {
				if (environmentResponse.page_activity
					&& !environmentResponse.page_activity[data.page_location]
				) {
					environmentResponse.page_activity[data.page_location] = [];
				}
				environmentResponse.page_activity[data.page_location].push(data);

				this.setState({ environmentResponse });
				break;
			}
			case "closed_dropdown": {
				// closing trailers
				for (let asset_id in trailersWatched) {
					if (!trailersWatched[asset_id].endTime) {
						trailersWatched[asset_id].endTime = data.time;
						let { startTime, endTime } = trailersWatched[asset_id];
						let assetDuration = assetsInfoMap[asset_id] ? assetsInfoMap[data.asset_id].duration : 0;
						trailersWatched[asset_id].completion = returnWatchComplete(assetDuration, startTime, endTime);

						assetsInfoMap[asset_id].show_details.trailer_completion = assetsInfoMap[asset_id].show_details.trailer_completion < trailersWatched[asset_id].completion || !assetsInfoMap[asset_id].show_details.trailer_completion ?
							trailersWatched[asset_id].completion
							:
							assetsInfoMap[asset_id].show_details.trailer_completion;

						assetsInfoMap[asset_id].show_details.time_interacted_with.push({
							start_time: trailersWatched[asset_id].startTime,
							end_time: trailersWatched[asset_id].endTime
						});
					}
				}
				currentTrailerAsset = null;
				// displayQuestionSet = this.displayQuestionSetCheck(fetchedPanel, stateParams, "asset_trailer_complete");
				// pathTracker = this.handlePathTrackerUpdate(fetchedPanel, data, 'watched', pathTracker, trailersWatched);
				break;
			}
			case "time_in_view": {
				let rowType = data.type; // 'row', 'poster', 'highlight'

				if (rowType === 'row' || rowType === 'poster') {
					rowInfoMap = returnTimeInViewObject(rowInfoMap, data);
				}
				else if (rowType === 'highlight') {
					midRowInfoMap = returnTimeInViewObject(midRowInfoMap, data);
				}
				break;
			}
			case "entered_curated_page": { // GA
				this.targetAssetInterval = setInterval(() => this.setState({ promptTargetAsset: true }), 60000);

				let gaLabel = 'curated_page';
				this.handleGoogleAnalytics(SVODStatusEvent.SVODSESSION_ENTERPAGE, gaLabel);
				break;
			}
			case "entered_target_asset_showpage": { // GA
				this.watchPageInterval = setInterval(() => this.setState({ promptWatchPage: true }), PROMPT_WATCH_PAGE_INTERVAL);

				let gaLabel = 'target_watch_page';
				this.handleGoogleAnalytics(SVODStatusEvent.SVODSESSION_ENTERPAGE, gaLabel);
				break;
			}
			case "prompt_curated_content": { // GA: see modal_open event
				modalType = 'prompt_curated_content';
				modalTitle = this.props.intl.formatMessage(svodModalMessages.prompt_curated_content_header);
				modalMessage = (
					<FormattedMessage
						id="svod_modals.prompt_curated_content_message"
						defaultMessage={`Thanks for exploring! As a next step, please scroll through “{value}” until you see the “View All” button. Hit “View All” and watch the TV show that you indicated wanting to watch the most.`}
						values={{ value: data.type }}
					/>
				);
				modalBackgroundCover = true;

				enableModalPrompt = true;
				this.setState({ promptCuratedRow: false }, () => {
					this.onReceiveEvent({
						data: {
							event_type: "modal_open",
							modal_name: "did_you_notice",
							page_location: "home_page",
							time: Date.now()
						}
					});
				});


				break;
			}
			case "display_welcome_modal": { // GA: see modal_open event
				modalType = 'display_welcome_modal';
				modalTitle = this.props.intl.formatMessage(svodModalMessages.welcome_modal_header);
				modalMessage = this.props.intl.formatMessage(svodModalMessages.welcome_modal_message);
				modalBackgroundCover = true;
				enableModalPrompt = true;

				this.setState({ isFirstSVODLoad: false }, () => {
					this.onReceiveEvent({
						data: {
							event_type: "modal_open",
							modal_name: "welcome",
							page_location: "home_page",
							time: Date.now()
						}
					});
				});
				break;
			}
			case "prompt_return_to_home_page": {
				modalType = 'prompt_return_to_home_page';
				modalTitle = this.props.intl.formatMessage(svodModalMessages.home_page_prompt_header);
				modalMessage = this.props.intl.formatMessage(svodModalMessages.home_page_prompt_message);
				if (data.page_location === "watch_page"
					|| data.page_location === "show_page"
				) {
					modalMessage = this.props.intl.formatMessage(svodModalMessages.home_page_prompt_watch_page_message);
				}

				modalBackgroundCover = true;
				enableModalPrompt = true;
				this.setState({ promptReturnToHomePage: false }, () => {
					this.onReceiveEvent({
						data: {
							event_type: "modal_open",
							modal_name: "prompt_return_to_home_page",
							page_location: data.page_location,
							time: Date.now()
						}
					});
				});
				break;
			}
			case "transaction": {
				modalType = 'transaction';
				modalTitle = this.props.intl.formatMessage(svodModalMessages.transaction_header);
				modalBackgroundCover = true;
				enableModalPrompt = true;

				modalMessage = (
					<FormattedMessage
						id="svod_modals.transaction_message"
						defaultMessage={`You have to pay for this content outside of your AppleTV+ subscription. This is not available at this time.`}
					/>
				);

				let { currentModal } = state;
				currentModal[data.page_location] = {
					page_location: data.page_location,
					name: "transaction",
					enter_time: Date.now(),
					exit_time: null,
				};

				let gaLabel = (data.page_location).replaceAll(/_/g, ' ');
				this.handleGoogleAnalytics(SVODStatusEvent.SVODSESSION_INFOMODAL, gaLabel);
				this.setState({ currentModal });
				break;
			}
			case "apple_prompt_to_target_asset": {
				if (!this.state.promptedTargetAsset) {
					let promptedTargetAsset = true;
					let autoNavigateToTargetAsset = false;
					const now = Date.now();

					modalType = isShowPageTargetGuided ? 'apple_force_to_target_asset' : 'apple_prompt_to_target_asset';
					modalTitle = this.props.intl.formatMessage(svodModalMessages.watch_page_prompt_header);
					modalBackgroundCover = true;
					enableModalPrompt = true;

					modalMessage = (
						<FormattedMessage
							id="svod_modals.watch_page_navigate_message"
							defaultMessage={`We’d now like you to check out "{value}", so please navigate to that show and watch the episode.`}
							values={{ value: data.targetAsset }}
						/>
					);

					if (isAppleTVGuided) {
						modalMessage = (
							<FormattedMessage
								id="svod_modals.watch_page_appletv_guided_prompt_message"
								defaultMessage={`You have access to bonus non-Apple TV+ original content with your subscription, please try and find that content on the homepage and explore for {minutes} minutes.`}
								values={{ minutes: APPLE_GUIDED_ADDED_LIMIT / 60 }}
							/>
						);
					}
					else if (isShowPageTargetGuided) {
						let targetAsset = svod_env.target_assets[targetAssetIndex];
						const targetAssetId = targetAsset ? targetAsset.id || targetAsset._id : "";
						let asset = targetAsset ? assetsInfoMap[targetAssetId] : null;
						if (asset) {
							modalMessage = (
								<FormattedMessage
									id="svod_modals.watch_page_target_guided_prompt_message"
									defaultMessage={`We are now going to take you to the Apple TV+ Original: {value}. We would like you to explore the page and find a title that is included with your subscription but is not a TV+ Original. You will have {minutes} minutes to explore this page.`}
									values={{ value: asset.name, minutes: APPLE_GUIDED_ADDED_LIMIT / 60 }}
								/>
							);
						}
					}

					let { currentModal } = state;
					currentModal[data.page_location] = {
						page_location: data.page_location,
						name: modalType,
						enter_time: now,
						exit_time: null,
					};

					let gaLabel = (data.page_location + `-${modalType}`).replaceAll(/_/g, ' ');
					this.handleGoogleAnalytics(SVODStatusEvent.SVODSESSION_INFOMODAL, gaLabel);
					this.setState({
						currentModal,
						promptedTargetAsset,
						autoNavigateToTargetAsset,
						targetAssetIndex,
						svodContinueTime: now
					});
				}

				break;
			}
			case "apple_force_to_target_asset": {
				if (!this.state.promptedForceTargetAsset) {
					const now = Date.now();
					modalType = 'apple_force_to_target_asset';
					modalTitle = this.props.intl.formatMessage(svodModalMessages.watch_page_prompt_header);
					modalBackgroundCover = true;
					enableModalPrompt = true;

					const value = isAppleTVGuided ? 'Included with AppleTV+ page' : data.targetAsset;
					modalMessage = (
						<FormattedMessage
							id="svod_modals.watch_page_force_message"
							defaultMessage={`We are now going to take you to "{value}", so please click "Continue" and watch the episode.`}
							values={{ value }}
						/>
					);

					if (isAppleTVGuided) {
						modalMessage = (
							<FormattedMessage
								id="svod_modals.watch_page_apple_bonus_content"
								defaultMessage={`We’ll now show you to a dedicated page of bonus content included with your AppleTV+ subscription, please explore this page for {minutes} minutes and click on any titles that interest you.`}
								values={{ minutes: APPLE_GUIDED_ADDED_LIMIT / 60 }}
							/>
						);
					}

					let { currentModal } = state;
					currentModal[data.page_location] = {
						page_location: data.page_location,
						name: "apple_force_to_target_asset",
						enter_time: now,
						exit_time: null,
					};

					let gaLabel = (data.page_location + '-apple_force_to_target_asset').replaceAll(/_/g, ' ');
					this.handleGoogleAnalytics(SVODStatusEvent.SVODSESSION_INFOMODAL, gaLabel);
					this.setState({
						currentModal,
						promptedForceTargetAsset: true,
						autoNavigateToIncludedAppleTVPage: false,
						autoNavigateToHome: false,
						svodContinueTime: now
					});
				}
				break;
			}
			case "apple_prompt_return_to_content": {
				modalType = 'apple_prompt_return_to_content';
				modalTitle = this.props.intl.formatMessage(svodModalMessages.return_to_target_content_header);
				modalMessage = this.props.intl.formatMessage(svodModalMessages.return_to_target_content_message);
				modalBackgroundCover = true;

				enableModalPrompt = true;

				if (this.state.returnToContentPromptCount >= APPLE_PROMPT_LIMIT) {
					this.handleTermination(this.props.fetchedGroup, SCREEN_CODES.BAD_RESPONDANT_CODE, "terminate", {}, SCREEN_REASONS.INVALID_ACTION);
					return;
				} else {
					this.onReceiveEvent({
						data: {
							event_type: "modal_open",
							modal_name: "apple_prompt_return_to_content",
							page_location: data.page_location,
							asset_name: data.asset_name,
							asset_id: data.asset_id,
							time: Date.now()
						}
					});
				}

				break;
			}
			case "peacock_prompt_to_target_asset": {
				if (!this.state.promptedTargetAsset) {
					let promptedTargetAsset = true;
					let autoNavigateToTargetAsset = false;
					const targetAsset = svod_env.target_assets[targetAssetIndex];
					const targetAssetId = targetAsset ? targetAsset.id || targetAsset._id : "";
					const asset = targetAsset ? assetsInfoMap[targetAssetId] : null;
					const now = Date.now();

					modalType = this.state.promptForcedTargetAsset ? 'peacock_force_to_target_asset' : 'peacock_prompt_to_target_asset';
					modalTitle = `Please go watch ${asset.name}`;
					modalBackgroundCover = true;
					enableModalPrompt = true;

					modalMessage = (
						<FormattedMessage
							id="svod_modals.watch_page_find_message"
							defaultMessage={`Thanks for exploring! As a next step, we’d like you to find {value} and watch the episode available.`}
							values={{ value: asset.name }}
						/>
					);

					if (this.state.promptForcedTargetAsset && asset) {
						modalMessage = (
							<FormattedMessage
								id="svod_modals.watch_page_having_trouble"
								defaultMessage={`Having trouble finding {value}? Click “continue” to be taken to the show page to watch the episode available`}
								values={{ value: asset.name }}
							/>
						);
					}

					let { currentModal } = state;
					currentModal[data.page_location] = {
						page_location: data.page_location,
						name: modalType,
						enter_time: now,
						exit_time: null,
					};

					let gaLabel = (data.page_location + `-${modalType}`).replaceAll(/_/g, ' ');
					this.handleGoogleAnalytics(SVODStatusEvent.SVODSESSION_INFOMODAL, gaLabel);
					this.setState({
						currentModal,
						promptedTargetAsset,
						autoNavigateToTargetAsset,
						targetAssetIndex,
						svodContinueTime: now,
						promptTargetAsset: false
					});
				}
				break;
			}
			case "peacock_force_to_target_asset": {
				// if (!this.state.promptedForceTargetAsset) { // Commented out to let the force modal to appear each time the user attempts to leave the target asset after being forced the first time
				const targetAsset = svod_env.target_assets[targetAssetIndex];
				const targetAssetId = targetAsset ? targetAsset.id || targetAsset._id : "";
				const asset = targetAsset ? assetsInfoMap[targetAssetId] : null;
				const now = Date.now();

				modalType = 'peacock_force_to_target_asset';
				modalTitle = `Please go watch ${asset.name}`;
				modalBackgroundCover = true;
				enableModalPrompt = true;

				modalMessage = (
					<FormattedMessage
						id="svod_modals.watch_page_having_trouble"
						defaultMessage={`Having trouble finding {value}? Click “continue” to be taken to the show page to watch the episode available`}
						values={{ value: asset.name }}
					/>
				);

				let { currentModal } = state;
				currentModal[data.page_location] = {
					page_location: data.page_location,
					name: modalType,
					enter_time: now,
					exit_time: null,
				};

				let gaLabel = (`${data.page_location}-${modalType}`).replaceAll(/_/g, ' ');
				this.handleGoogleAnalytics(SVODStatusEvent.SVODSESSION_INFOMODAL, gaLabel);
				this.setState({
					currentModal,
					svodContinueTime: now,
					autoNavigateToHome: false,
					autoNavigateToTargetAsset: false,
					promptedForceTargetAsset: true,
					promptForcedTargetAsset: false
				});
				// }
				break;
			}
			case "peacock_prompt_return_to_content": {
				break;
			}
			case "end_auto_navigation": {
				this.setState({ autoNavigateToTargetAsset: false, autoNavigateToIncludedAppleTVPage: false, autoNavigateToHome: false });
				break;
			}
			case "prompt_final_step_confirmation": {
				modalType = 'prompt_final_step_confirmation';
				modalTitle = this.props.intl.formatMessage(svodModalMessages.final_step_confirmation_header);
				modalMessage = this.props.intl.formatMessage(svodModalMessages.final_step_confirmation_message);
				modalBackgroundCover = true;

				enableModalPrompt = true;
				this.onReceiveEvent({
					data: {
						event_type: "modal_open",
						modal_name: "final_step_confirmation",
						page_location: "home_page",
						time: Date.now()
					}
				});

				break;
			}
			case "prompt_target_asset": { // GA: see modal_open event
				modalType = 'prompt_target_asset';
				modalTitle = (
					<FormattedMessage
						id="svod_modals.prompt_target_asset_title"
						defaultMessage={`Please Select "{value}"`}
						values={{ value: data.type }}
					/>
				);
				modalMessage = (
					<FormattedMessage
						id="svod_modals.prompt_target_asset_message"
						defaultMessage={`For your next step, please click on "{value}" to navigate to the show's page.`}
						values={{ value: data.type }}
					/>
				);
				modalBackgroundCover = true;

				enableModalPrompt = true;
				this.setState({ promptTargetAsset: false }, () => {
					this.onReceiveEvent({
						data: {
							event_type: "modal_open",
							modal_name: "view_this_asset",
							page_location: "curated_page",
							time: Date.now()
						}
					});
				});

				break;
			}
			case "prompt_watch_page": { // GA: see modal_open event
				modalType = 'prompt_watch_page';
				modalTitle = this.props.intl.formatMessage(svodModalMessages.prompt_watch_page_header);
				modalMessage = (
					<FormattedMessage
						id="svod_modals.prompt_watch_page_message"
						defaultMessage={`As a next step, please click on the "Watch Now" button to start the episode for "{value}".`}
						values={{ value: data.type }}
					/>
				);
				modalBackgroundCover = true;
				enableModalPrompt = true;
				this.onReceiveEvent({ data: { event_type: "modal_open", modal_name: "watch_episode", page_location: "show_page", time: Date.now() } });
				break;
			}
			case "peacock_ad_choice_update": {
				break;
			}
			case "ad_unit_started": {
				if (!environmentResponse.ad_unit_activity) environmentResponse.ad_unit_activity = {};
				environmentResponse.ad_unit_activity[data.asset_id] = {
					name: data.asset_name,
					started: true,
					displayed: false,
					user_choice: null,
					completed: false
				};
				break;
			}
			case "ad_unit_displayed": {
				environmentResponse.ad_unit_activity[data.asset_id].displayed = true;
				break;
			}
			case "ad_unit_optin": {
				environmentResponse.ad_unit_activity[data.asset_id].user_choice = 'optin';
				break;
			}
			case "ad_unit_optout": {
				environmentResponse.ad_unit_activity[data.asset_id].user_choice = 'optout';
				break;
			}
			case "ad_unit_cancel": {
				environmentResponse.ad_unit_activity[data.asset_id].user_cancelled = true;
				break;
			}
			case "ad_unit_notavailable": {
				environmentResponse.ad_unit_activity[data.asset_id].user_choice = 'ad_not_available';
				break;
			}
			case "ad_unit_completed": {
				environmentResponse.ad_unit_activity[data.asset_id].completed = true;
				break;
			}
			case "logout": {
				if (event.data.completedTargetAsset) {
					if (fetchedGroup.svod_env.environment_vendor === EnvType.PEACOCK) {
						modalTitle = this.props.intl.formatMessage(svodModalMessages.peacock_logout_modal_header);
						modalMessage = this.props.intl.formatMessage(svodModalMessages.peacock_logout_modal_message);
						modalType = 'force-logout';
						modalBackgroundCover = true;

						this.onReceiveEvent({ data: { event_type: "modal_open", modal_name: "logout", page_location: "watch_page", time: Date.now() } });
					}
					else if ((isAppleTVGuided || isShowPageTargetGuided)
						&& fetchedGroup.svod_env.environment_vendor === EnvType.APPLETV
					) {
						modalTitle = this.props.intl.formatMessage(svodModalMessages.logout_modal_header);
						modalMessage = this.props.intl.formatMessage(svodModalMessages.logout_svod_modal_message);
						modalType = 'force-logout';
						modalBackgroundCover = true;
						enableModalPrompt = true;

						this.onReceiveEvent({ data: { event_type: "modal_open", modal_name: "logout", page_location: "watch_page", time: Date.now() } });
					}
					else if (fetchedGroup.svod_env.environment_vendor === EnvType.APPLETV) {
						directExitToSurvey = true;
						if (data.asset_id) updateAssetsWatchedTracking(data);
					}
				}
				else {
					modalType = 'logout';

					if (data.title && data.description) {
						modalTitle = data.title;
						modalMessage = data.description;
						modalType = 'timeout';
					} else {
						let environment = (this.props.fetchedGroup.svod_env.environment_vendor === "netflix" ? "Netflix" : "streaming");
						modalTitle = this.props.intl.formatMessage(svodModalMessages.logout_of_experience);
						modalMessage = (
							<FormattedMessage
								id="svod_modals.logout_of_experience_message"
								defaultMessage={`You are about to logout of the "{value}" portion of the experience. Are you sure you want to continue to the survey portion of this study?`}
								values={{ value: environment }}
							/>
						);
					}
				}

				/* Google analytics event - logout */
				let svodStatus = new SVODStatus(SVODStatusEvent.SVODACTION_LOGOUT, '', '', false, false, true, false);
				svodStatus.gaTracker = this.props.tracker;
				svodStatus.state = this.state;
				svodStatus.label = 'complete';
				this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

				enableExitSurvey = true;
				environmentResponse.exit_svod = true;

				let updatedAssetInteractions = returnUpdatedAssetInteractions(
					environmentResponse,
					trailersWatched,
					currentTrailerAsset,
					assetsInfoMap,
					rowInfoMap,
					myListInfoMap,
					data,
					startTimeInSVOD,
					promosInfoMap,
				);

				environmentResponse = updatedAssetInteractions.environmentResponse;
				trailersWatched = updatedAssetInteractions.trailersWatched;
				currentTrailerAsset = updatedAssetInteractions.currentTrailerAsset;
				assetsInfoMap = updatedAssetInteractions.assetsInfoMap;
				rowInfoMap = updatedAssetInteractions.rowInfoMap;
				myListInfoMap = updatedAssetInteractions.myListInfoMap;

				this.handleEnvironmentResponse(environmentResponse);
				break;
			}
		}

		let stateParams = {
			viewCount,
			commentCount,
			fullscreensWatched,
			promosWatched,
			trailersWatched,
			currentTrailerAsset,
			questionSetsDisplayed,
			timeInSVOD,
			environmentResponse
		};

		displayQuestionSet = this.displayQuestionSetCheck(fetchedPanel, stateParams, data);
		// if (displayQuestionSet && displayQuestionSet.qset_index_key && !qset_asset && !watchingFullScreen) {
		if (displayQuestionSet && displayQuestionSet.qset_index_key) {
			questionSetsDisplayed.push(displayQuestionSet.qset_index_key);
			trailersWatched = closeAllTrailers(trailersWatched, data);
			qset_asset = displayQuestionSet.qset_asset;
		}

		this.setState({
			assetsInfoMap,
			rowInfoMap,
			midRowInfoMap,
			myListInfoMap,
			environmentResponse,
			modalTitle,
			modalMessage,
			modalType,
			modalBackgroundCover,

			questionSetIndex,
			questionIndex,
			pathTracker,
			viewCount,
			commentCount,
			fullscreensWatched,
			trailersWatched,
			currentTrailerAsset,
			questionSetsDisplayed,
			watchingFullScreen,

			qset_asset
		}, () => {
			// if (displayQuestionSet && qset_asset && !enableExitSurvey) this.handleQsetIndex(displayQuestionSet.qset_index);
			if (displayQuestionSet && !enableExitSurvey) this.handleQsetIndex(displayQuestionSet.qset_index);
			else if (directExitToSurvey) this.handleQsetIndex('exit');
			else if (enableExitSurvey || enableModalPrompt) this.handleOpenModal(modalTitle, modalMessage, modalType, modalBackgroundCover); // this.handleQsetIndex('exit');
		});
	}

	displayQuestionSetCheck(fetchedPanel, stateParams, eventData) {
		// Logger.log(this.constructor.name, "displayQuestionSetCheck()", "VIEW COUNT:", stateParams.viewCount, "COMMENT COUNT", stateParams.commentCount, "CURRENT TRAILER ASSET:", stateParams.currentTrailerAsset);

		{/* STATE PARAMS:
			timeInSVOD            - the time (seconds) that a viewer has spent in the SVOD environment
			viewCount             - the number of assets viewed by the user
			commentCount          - the number comments submitted by the user
			fullscreensWatched    - an object of assets viewed by the user with { startTime, endTime, duration, completion }
			trailersWatched       - an object of trailers viewed by the user with { startTime, endTime, duration, completion }
			currentTrailerAsset   - the id of the current trailer asset being viewed by the user
			questionSetsDisplayed - the question sets completed by the user
		*/}

		let returnQuestionSetCheck = (environmentAction, eventType, stateParams, eventData) => {
			switch (eventType) {
				case "user_path": {
					let qset_index_key = environmentAction.views + '-' + environmentAction.qset_index;
					if (environmentAction.views === stateParams.viewCount &&
						!stateParams.questionSetsDisplayed.includes(qset_index_key)
					) {
						return {
							qset_index: environmentAction.qset_index,
							qset_index_key: qset_index_key
						};
					}
					break;
				}
				case "asset_trailer_complete": { // asset_id is added as a prefix to the qid and aid to the panel response					
					for (let asset_id in stateParams.trailersWatched) {
						let qset_index_key = asset_id + '-' + environmentAction.qset_index;
						let completionLogicIsValid = environmentAction.logic === 'lessthan' ?
							stateParams.trailersWatched[asset_id].completion <= environmentAction.completion
							:
							stateParams.trailersWatched[asset_id].completion >= environmentAction.completion;

						let timeEngaged = 0;
						if (stateParams.trailersWatched[asset_id]) {
							timeEngaged = (stateParams.trailersWatched[asset_id].endTime - stateParams.trailersWatched[asset_id].startTime) / 1000;
						}

						if (asset_id &&
							stateParams.trailersWatched[asset_id] &&
							timeEngaged >= MINIMUM_TIME_ENGAGED &&
							completionLogicIsValid &&
							!stateParams.questionSetsDisplayed.includes(qset_index_key)
						) {
							return {
								qset_index: environmentAction.qset_index,
								qset_index_key: qset_index_key,
								qset_asset: asset_id
							};
						}
					}
					break;
				}
				case "asset_fullscreen_playback": { // asset_id is added as a prefix to the qid and aid to the panel response

					let watchedAssetsLists = [stateParams.fullscreensWatched, stateParams.promosWatched];

					for (let index = 0; index < watchedAssetsLists.length; index++) {
						let watchedAssetsList = watchedAssetsLists[index];

						for (let asset_id in watchedAssetsList) {
							let qset_index_key = asset_id + '-' + environmentAction.qset_index;
							let completionLogicIsValid = environmentAction.logic === 'lessthan' ?
								watchedAssetsList[asset_id].completion <= environmentAction.completion
								:
								watchedAssetsList[asset_id].completion >= environmentAction.completion;

							let timeEngaged = 0;
							if (watchedAssetsList[asset_id]) {
								timeEngaged = (watchedAssetsList[asset_id].endTime - watchedAssetsList[asset_id].startTime) / 1000;
							}

							if (asset_id &&
								watchedAssetsList[asset_id] &&
								timeEngaged >= MINIMUM_TIME_ENGAGED &&
								completionLogicIsValid &&
								!stateParams.questionSetsDisplayed.includes(qset_index_key)
							) {
								return {
									qset_index: environmentAction.qset_index,
									qset_index_key: qset_index_key,
									qset_asset: asset_id
								};
							}
						}
					}
					break;
				}
				case "user_commentary": {
					let qset_index_key = environmentAction.comment_count + '-' + environmentAction.qset_index;
					if (environmentAction.comment_count === stateParams.commentCount &&
						!stateParams.questionSetsDisplayed.includes(qset_index_key)
					) {
						return {
							qset_index: environmentAction.qset_index,
							qset_index_key: qset_index_key
						};
					}
					break;
				}
				case "asset_engagement": { // asset_id is added as a prefix to the qid and aid to the panel response. Currently asset_engagement is used specifically for full screen watches. 

					for (let asset_id in stateParams.fullscreensWatched) {
						let qset_index_key = asset_id + '-' + environmentAction.qset_index;
						let completionLogicIsValid = environmentAction.logic === 'lessthan' ?
							stateParams.fullscreensWatched[asset_id].completion <= environmentAction.completion
							:
							stateParams.fullscreensWatched[asset_id].completion >= environmentAction.completion;

						let timeEngaged = 0;
						if (stateParams.fullscreensWatched[asset_id]) {
							timeEngaged = (stateParams.fullscreensWatched[asset_id].endTime - stateParams.fullscreensWatched[asset_id].startTime) / 1000;
						}

						if (asset_id &&
							environmentAction.asset_id &&
							environmentAction.asset_id.valueOf() === asset_id &&
							stateParams.fullscreensWatched[asset_id] &&
							timeEngaged >= MINIMUM_TIME_ENGAGED &&
							completionLogicIsValid &&
							!stateParams.questionSetsDisplayed.includes(qset_index_key)
						) {
							return {
								qset_index: environmentAction.qset_index,
								qset_index_key: qset_index_key,
								qset_asset: asset_id
							};
						}
					}
					break;
				}
				case "session_length": {
					let secondsInSVOD = environmentAction.time_in_session * 60;
					let qset_index_key = secondsInSVOD + '-' + environmentAction.qset_index;
					if (stateParams.timeInSVOD >= secondsInSVOD &&
						!stateParams.questionSetsDisplayed.includes(qset_index_key)
					) {
						return {
							qset_index: environmentAction.qset_index,
							qset_index_key: qset_index_key
						};
					}
					break;
				}
				case "skip_button_clicked": {
					for (let button_click_index = 0; button_click_index < stateParams.environmentResponse.button_click_activity.length; button_click_index++) {
						let button_click = stateParams.environmentResponse.button_click_activity[button_click_index];
						let qset_index_key = button_click.promo_id + '-' + environmentAction.qset_index;

						if (button_click.type === "skip_click" &&
							button_click.promo_id &&
							stateParams.promosWatched[button_click.asset_id] &&
							stateParams.promosWatched[button_click.asset_id].endTime &&
							!stateParams.questionSetsDisplayed.includes(qset_index_key)
						) {
							return {
								qset_index: environmentAction.qset_index,
								qset_index_key: qset_index_key,
								qset_asset: button_click.promo_id
							};
						}
					}
					break;
				}
				case 'skip_button_not_clicked': {

					for (let button_click_index = 0; button_click_index < stateParams.environmentResponse.button_click_activity.length; button_click_index++) {
						let button_click = stateParams.environmentResponse.button_click_activity[button_click_index];
						let qset_index_key = button_click.promo_id + '-' + environmentAction.qset_index;

						if (button_click.type === "skip_not_clicked" &&
							button_click.promo_id &&
							stateParams.promosWatched[button_click.asset_id] &&
							stateParams.promosWatched[button_click.asset_id].endTime &&
							!stateParams.questionSetsDisplayed.includes(qset_index_key)
						) {
							return {
								qset_index: environmentAction.qset_index,
								qset_index_key: qset_index_key,
								qset_asset: button_click.promo_id
							};
						}
					}
				}
			}
			return null;
		};

		if (fetchedPanel &&
			fetchedPanel.env_actions &&
			fetchedPanel.env_actions.length
		) {
			for (let i = 0; i < fetchedPanel.env_actions.length; i++) {
				let environmentAction = fetchedPanel.env_actions[i];
				if (environmentAction.qset_index) {
					let questionSetCheck = returnQuestionSetCheck(environmentAction, environmentAction.event_type, stateParams, eventData);
					if (questionSetCheck) return questionSetCheck;
				}
			}
		}

		return false;
	}

	checkQuestionExitConditions(question, aid, aid_set) {
		let exitDisplay = "";

		if (question && question.exit_conditions && question.exit_conditions.length) {
			for (let i = 0; i < question.exit_conditions.length; i++) {
				let exitCondition = question.exit_conditions[i];
				switch (true) {
					case (exitCondition.action === "select" && exitCondition.condition !== "morethan" && exitCondition.condition !== "lessthan"): {
						if (aid) {
							exitDisplay = exitCondition.aid === aid ? 'terminate' : exitDisplay;
						}
						else if (aid_set && aid_set.length && aid_set.includes(exitCondition.aid)) {
							exitDisplay = 'terminate';
						}
						break;
					}
					case (exitCondition.action === "not-select"): {
						let answerSelected = false;
						if (aid_set && aid_set.length && aid_set.includes(exitCondition.aid)) {
							answerSelected = true;
						}
						if (!answerSelected) {
							exitDisplay = 'terminate';
						}
						break;
					}
					case ((exitCondition.action === "select" && exitCondition.condition === "morethan") ||
						(exitCondition.action === "select" && exitCondition.condition === "lessthan")): {
							if (aid_set && aid_set.length) {
								let answerSelectionCount = 0;
								for (let i = 0; i < aid_set.length; i++) {
									let aid = aid_set[i];
									if (exitCondition.aid_set && exitCondition.aid_set.includes(aid)) {
										answerSelectionCount++;
									}
								}
								// 'lessthan' ?  '>' : '<'
								let operator = exitCondition.condition === 'lessthan' ? '<' : '>';
								let processExit = this.returnDynamicInequality(exitCondition.count, operator, answerSelectionCount);
								if (processExit) {
									exitDisplay = 'terminate';
								}
							}
							break;
						}
				}
				if (exitDisplay) {
					break;
				}
			}
		}
		return exitDisplay;
	}

	retryFinalDataSubmission() {
		// Logger.log(this.constructor.name, "retryFinalDataSubmission()");
	}

	handleBillboardAsset(billboardAsset) {
		this.setState({ billboardAsset });
	}

	handleQuestionIndexOverride(updatedQuestionIndex) {
		updatedQuestionIndex = updatedQuestionIndex ? updatedQuestionIndex : 0;
		this.setState({ questionIndex: updatedQuestionIndex });
	}

	handleTimedExperience(forceLogout) {
		let time = Date.now();
		let { startTimeInSVOD, watchingFullScreen, environmentResponse } = this.state;
		let timeInSVOD = startTimeInSVOD ? (time - startTimeInSVOD) / 1000 : time;
		let timeoutBlocked = this.props.fetchedGroup.svod_env.environment_vendor === EnvType.PEACOCK || this.props.fetchedGroup.svod_env.environment_vendor === EnvType.APPLETV;
		let endSVODExperience = forceLogout || (!timeoutBlocked && !watchingFullScreen && timeInSVOD >= TIMEOUT_LIMIT); // 1800 seconds = 30 minutes;
		if (!environmentResponse.start_time_in_env) environmentResponse.start_time_in_env = time;

		Logger.log(this.constructor.name, "handleTimedExperience():", timeInSVOD);

		this.setState({
			environmentResponse,
			timeInSVOD,
			endSVODExperience
		}, () => {
			if (endSVODExperience) {

				/* Google analytics event - Session Timeout */
				let svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_ERROR, '', '', false, false, true, false);
				svodStatus.gaTracker = this.props.tracker;
				svodStatus.state = this.state;
				svodStatus.label = 'timeout';
				this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

				let eventObj = {
					data: {
						event_type: 'logout',
						time: time,
						type: 'session_end',
						title: 'Timed out Experience',
						description: "Your SVOD experience has concluded. We'll be forwarding you to the exit portion of the study."
					}
				};
				this.onReceiveEvent(eventObj);
			}
		});
	}

	handleCuratedPrompt() {
		let time = Date.now();
		let { startTimeInSVOD } = this.state;
		let timeSinceBeginningSVOD = startTimeInSVOD ? (time - startTimeInSVOD) / 1000 : time / 1000;
		let promptCuratedRow = timeSinceBeginningSVOD >= CURATED_PROMPT_LIMIT;
		if (promptCuratedRow) this.setState({ promptCuratedRow });
	}

	beginGuidedExperience() {
		let time = Date.now();
		let { startTimeInSVOD, svodContinueTime, beginAppleGuidedExperience } = this.state;
		let timeInSVOD = svodContinueTime ? (time - svodContinueTime) / 1000 : time;
		const beginAppleGuidedExperienceUpdate = timeInSVOD >= APPLE_GUIDED_EXPERIENCE_LIMIT;

		if (!beginAppleGuidedExperience) {
			this.setState({
				beginAppleGuidedExperience: beginAppleGuidedExperienceUpdate
			});
		}
	}

	forceGuidedExperience() {
		let time = Date.now();
		let { startTimeInSVOD, svodContinueTime, forceGuidedExperience } = this.state;
		let timeInSVOD = svodContinueTime ? (time - svodContinueTime) / 1000 : time;
		let forceGuidedExperienceUpdate = timeInSVOD >= APPLE_FORCE_GUIDED_EXPERIENCE_LIMIT;

		if (!forceGuidedExperience) {
			this.setState({
				forceGuidedExperience: forceGuidedExperienceUpdate
			});
		}
	}

	handlePromptToHomePage() {
		let time = Date.now();
		let { beganSVODExperienceTime } = this.state;
		let timeSinceBeginningSVOD = beganSVODExperienceTime ? (time - beganSVODExperienceTime) / 1000 : time / 1000;
		let promptReturnToHomePage = timeSinceBeginningSVOD >= CURATED_PROMPT_LIMIT;
		if (promptReturnToHomePage) this.setState({ promptReturnToHomePage });
	}

	handleTargetAssetPrompt() {
		let time = Date.now();
		let { svodContinueTime, promptTargetAsset } = this.state;
		let timeInSVOD = svodContinueTime ? (time - svodContinueTime) / 1000 : time;
		let promptTargetAssetUpdate = timeInSVOD >= CURATED_PROMPT_LIMIT;
		if (!promptTargetAsset) this.setState({ promptTargetAsset: promptTargetAssetUpdate });
	}

	handleForceTargetAssetPrompt() {
		let time = Date.now();
		let { svodContinueTime, promptForcedTargetAsset } = this.state;
		let timeInSVOD = svodContinueTime ? (time - svodContinueTime) / 1000 : time;
		let promptForcedTargetAssetUpdate = timeInSVOD >= CURATED_PROMPT_LIMIT;
		if (!promptForcedTargetAsset) this.setState({ promptForcedTargetAsset: promptForcedTargetAssetUpdate });
	}

	handlePathTrackerUpdate(panel, eventData, eventAction, pathTracker, assetsWatched, buttonClicks, param_id) {
		// Logger.log(this.constructor.name, 'handlePathTrackerUpdate()', eventAction);
		if (panel && panel.env_actions && panel.env_actions.length) {
			switch (eventAction) {
				case "start-watch": case "commented": {
					let timeEngaged = 0;
					let isStartWatchEventAction = eventAction === 'start-watch';
					let asset_id = param_id ? eventData[param_id] : eventData.asset_id;
					if (assetsWatched
						&& assetsWatched[asset_id]
						&& isNumber(assetsWatched[asset_id].startTime)
						&& isNumber(assetsWatched[asset_id].endTime)
						&& assetsWatched[asset_id].endTime
					) {
						timeEngaged = (assetsWatched[asset_id].endTime - assetsWatched[asset_id].startTime) / 1000;
					}

					panel.env_actions.forEach((environmentAction) => {
						if (environmentAction.path
							&& environmentAction.action === eventAction
							&& environmentAction.asset_id
							&& environmentAction.asset_id.valueOf() === asset_id
							&& !pathTracker.includes(environmentAction.path)
							&& (!isStartWatchEventAction || (isStartWatchEventAction && timeEngaged >= MINIMUM_TIME_ENGAGED))
						) {
							pathTracker.push(environmentAction.path);
						}
					});
					break;
				}
				case "watched": {
					let asset_id = param_id ? eventData[param_id] : eventData.asset_id;
					panel.env_actions.forEach((envAction) => {
						panel.env_actions.forEach((environmentAction) => {
							let completionLogicIsValid = false;
							if (environmentAction.asset_id && assetsWatched[environmentAction.asset_id.valueOf()]) {
								completionLogicIsValid = environmentAction.logic === 'lessthan' ?
									assetsWatched[environmentAction.asset_id.valueOf()].completion <= environmentAction.completion
									:
									assetsWatched[environmentAction.asset_id.valueOf()].completion >= environmentAction.completion;
							}

							if (environmentAction.path &&
								environmentAction.action === eventAction &&
								environmentAction.asset_id &&
								environmentAction.asset_id.valueOf() === asset_id &&
								environmentAction.completion &&
								assetsWatched[environmentAction.asset_id.valueOf()] &&
								assetsWatched[environmentAction.asset_id.valueOf()].completion &&
								completionLogicIsValid &&
								!pathTracker.includes(environmentAction.path)
							) {
								pathTracker.push(environmentAction.path);
							}
						});
					});
					break;
				}
				case "not-watched": {
					let asset_id = param_id ? eventData[param_id] : eventData.asset_id;
					panel.env_actions.forEach((environmentAction) => {
						if (environmentAction.path &&
							environmentAction.action === eventAction &&
							environmentAction.asset_id &&
							environmentAction.asset_id.valueOf() === asset_id &&
							!pathTracker.includes(environmentAction.path)
						) {
							pathTracker.push(environmentAction.path);
						}
					});
					break;
				}
				case "skip-clicked": {
					if (buttonClicks &&
						buttonClicks.length
					) {
						let promo_id = null;
						let asset_id = param_id ? eventData[param_id] : eventData.asset_id;
						for (let button_click_index = 0; button_click_index < buttonClicks.length; button_click_index++) {
							let button_click = buttonClicks[button_click_index];
							let button_click_asset_id = param_id ? button_click[param_id] : button_click.asset_id;

							if (button_click_asset_id &&
								asset_id &&
								button_click_asset_id === asset_id.valueOf() &&
								button_click.type === "skip_click" &&
								button_click.promo_id
							) {
								promo_id = button_click.promo_id;
								break;
							}
						}

						if (promo_id) {
							panel.env_actions.forEach((environmentAction) => {
								if (environmentAction.path &&
									environmentAction.action === eventAction &&
									environmentAction.asset_id &&
									environmentAction.asset_id.valueOf() === promo_id &&
									!pathTracker.includes(environmentAction.path)
								) {
									pathTracker.push(environmentAction.path);
								}
							});
						}
					}
					break;
				}
				case "skip-not-clicked": {
					if (buttonClicks &&
						buttonClicks.length
					) {
						let promo_id = null;
						let asset_id = param_id ? eventData[param_id] : eventData.asset_id;

						for (let button_click_index = 0; button_click_index < buttonClicks.length; button_click_index++) {
							let button_click = buttonClicks[button_click_index];
							let button_click_asset_id = param_id ? button_click[param_id] : button_click.asset_id;

							if (button_click_asset_id &&
								asset_id &&
								button_click_asset_id === asset_id.valueOf() &&
								button_click.type === "skip_not_clicked" &&
								button_click.promo_id
							) {
								promo_id = button_click.promo_id;
								break;
							}
						}
						if (promo_id) {
							panel.env_actions.forEach((environmentAction) => {
								if (environmentAction.path &&
									environmentAction.action === eventAction &&
									environmentAction.asset_id &&
									environmentAction.asset_id.valueOf() === promo_id &&
									!pathTracker.includes(environmentAction.path)
								) {
									pathTracker.push(environmentAction.path);
								}
							});
						}
					}
					break;
				}
			}
		}
		return pathTracker;
	}

	handleProgressUpdate(questionIndex, questionSetIndex, selectedPaths, selectedAnswers, screenCode, question, questionValidation) {
		// Logger.log(this.constructor.name, "handleProgressUpdate() QINDEX:", questionIndex, "QSET-INDEX:", questionSetIndex, "MAX QSET-INDEX:", this.state.maxQsetIndex);
		let state = { ...this.state };
		let feedbackType = "";
		let {
			environmentResponse,
			pathTracker,
			answerTracker,
			questionSetMap,
			maxQsetIndex,
			enableSurveySet,
			questionSetsDisplayed,
			goodwill,
			startTimeInSVOD,
			qset_asset,
			svodStartTime,
			svodContinueTime
		} = state;

		/* init the svod interval */
		if (questionSetIndex === 1 &&
			this.state.questionSetIndex !== questionSetIndex
		) {
			svodStartTime = Date.now();
			environmentResponse.start_time_in_env = svodStartTime;
			startTimeInSVOD = svodStartTime;
			svodContinueTime = svodStartTime;

			this.interval = setInterval(() => this.handleTimedExperience(), 120000);
			this.beginGuidedExperienceInterval = setInterval(() => this.beginGuidedExperience(), 1000);
		}

		/* update the goodwill */
		if (this.state.questionSetIndex !== questionSetIndex) {
			enableSurveySet = false;
			qset_asset = '';
			let action = questionSetIndex === maxQsetIndex ? 'inVideoSurvey' : 'postrollList';
			goodwill = this.returnUpdatedGoodwill(action);
		}

		/* update the path tracker */
		if (selectedPaths && selectedPaths.length) {
			pathTracker = pathTracker.concat(selectedPaths);
		}

		/* update the answer tracker */
		if (selectedAnswers && Array.isArray(selectedAnswers) && selectedAnswers.length) {
			answerTracker = answerTracker.concat(selectedAnswers);
		}

		feedbackType = this.returnFeedbackType(screenCode);
		if (screenCode && feedbackType !== "thankyou") {
			this.handleTermination(this.props.fetchedGroup, screenCode, feedbackType, question, questionValidation.reason);
		}
		else {
			/* Google analytics event - Survey */
			let svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_ENDSURVEY, '', '', false, false, true, false);
			svodStatus.gaTracker = this.props.tracker;
			svodStatus.state = this.state;
			svodStatus.label = `survey_completed`;
			this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

			if (!questionSetMap[questionSetIndex]) { feedbackType = 'thankyou'; }
			Logger.log(this.constructor.name, "handleProgressUpdate() QINDEX:", questionIndex, "QSET-INDEX:", questionSetIndex);
			this.setState({
				environmentResponse,
				questionIndex,
				questionSetIndex,
				feedbackType,
				enableSurveySet,
				pathTracker,
				answerTracker,
				questionSetsDisplayed,
				goodwill,
				startTimeInSVOD,
				qset_asset,
				svodStartTime,
				svodContinueTime
			}, () => {
				this.props.toggleActiveSurvey(enableSurveySet);
				if (questionValidation
					&& questionValidation.reason
				) {
					this.handleBadRespondents(questionValidation);
				}
			});
		}

	}

	handleAnalyticsEvent() {
		// Logger.log(this.constructor.name, "handleAnalyticsEvent()");
	}

	handleBadRespondents(validation) {
		Logger.log(this.constructor.name, "handleBadRespondents() REASON:", validation.reason, "QID:", validation.qid, "QTYPE:", validation.type);
		if (!validation || !validation.reason) return;

		const { goodwill } = this.state;
		const { fetchedGroup, targetParams } = this.props;

		Logger.log(this.constructor.name, "processBadRespondant()", validation.reason, goodwill);

		const tokens = goodwill && goodwill.tokens ? goodwill.tokens : -1;

		// const checkBadRespondant = urlParams ? urlParams.checkBadRespondant : false;

		Logger.log(this.constructor.name, "handleBadRespondents() TOKENS:", tokens);
		if (tokens < 1) {
			this.handleTermination(fetchedGroup, SCREEN_CODES.BAD_RESPONDANT_CODE, 'terminate', validation, validation.reason);
		}
		else if (tokens > 0) {
			let updatedGoodwill = this.returnUpdatedGoodwill("lose_token");
			Logger.log(this.constructor.name, "processBadRespondant() let it slide, taking a token, " + (tokens - 1) + " remaining");
			this.setState({ goodwill: updatedGoodwill });
		}
	}

	handleError() {
		// Logger.log(this.constructor.name, "handleError()");
	}

	//  method to test question set routing
	handleQsetIndex(surveySet) {
		/* Google analytics event - Survey */
		let svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_STARTSURVEY, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.state = this.state;
		svodStatus.label = surveySet;
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

		let { questionSetIndex, questionIndex, maxQsetIndex, goodwill, environmentResponse, qset_asset } = this.state;
		let enableSurveySet = false;
		switch (true) {
			case (surveySet === 'in-video'): {
				questionIndex = 0;
				questionSetIndex = questionSetIndex >= maxQsetIndex ? maxQsetIndex : questionSetIndex;
				goodwill = this.returnUpdatedGoodwill('inVideoSurvey');
				// questionSetsDisplayed.push(questionSetIndex);
				enableSurveySet = true;
				break;
			}
			case (surveySet === 'exit'): {
				this.onReceiveEvent({ data: { event_type: "modal_close", modal_name: "logout", page_location: "watch_page", time: Date.now() } });

				questionIndex = 1;
				enableSurveySet = true;
				questionSetIndex = maxQsetIndex;
				goodwill = this.returnUpdatedGoodwill('postrollList');
				qset_asset = '';

				clearInterval(this.interval);
				clearInterval(this.curatedInterval);
				clearInterval(this.promptToHomePageInterval);
				clearInterval(this.targetAssetInterval);
				clearInterval(this.watchPageInterval);
				clearInterval(this.beginGuidedExperienceInterval);
				clearInterval(this.forceGuidedExperienceInterval);
				clearInterval(this.endingAppleTVPlusExperienceInterval);

				this.handleCloseModal();
				this.handleEnvironmentResponse(environmentResponse);
				// questionSetsDisplayed.push(questionSetIndex);
				break;
			}
			case (!isNaN(surveySet)): {
				questionIndex = 0;
				questionSetIndex = surveySet;
				goodwill = this.returnUpdatedGoodwill('inVideoSurvey');
				// questionSetsDisplayed.push(questionSetIndex);
				enableSurveySet = true;
				break;
			}
		}

		Logger.log(this.constructor.name, "handleQsetIndex() QINDEX:", questionIndex, "QSET-INDEX:", questionSetIndex);
		this.setState({
			questionSetIndex,
			enableSurveySet,
			questionIndex,
			goodwill,
			qset_asset
		}, () => {
			this.props.toggleActiveSurvey(enableSurveySet);
		});
	}

	// SVOD MODAL - enables a modal with title and message text
	handleOpenModal(modalTitle, modalMessage, modalType, modalBackgroundCover) {
		const environmentModal = this.grabEnvironmentModalType();
		this.setState({
			modalTitle,
			modalMessage,
			modalType,
			modalBackgroundCover,
			enterModalTimestamp: Date.now()
		}, () => window.$(`#${environmentModal}`).modal('open'));
	}

	// SVOD MODAL - handles the closing of the SVOD mobal
	handleCloseModal(type) {
		let { totalModalTime, enterModalTimestamp } = this.state;

		const environmentModal = this.grabEnvironmentModalType(); // the environment class specific to the svod type
		const exitModalTimestamp = Date.now();
		totalModalTime += exitModalTimestamp - enterModalTimestamp;

		window.$(`#${environmentModal}`).modal('close');
		this.setState({
			modalBackgroundCover: false,
			totalModalTime
		});
	}

	// SVOD MODAL - closes the Peacock specific welcome modal
	// This also begins the curation prompt intervals for peacock
	handleClosePeacockWelcomeModal() {
		const { svod_env } = this.props.fetchedGroup;
		let environmentModal = this.grabEnvironmentModalType();
		window.$(`#${environmentModal}`).modal('close');

		// enables the curated prompt modal for peacock. This is only enabled by the parameter curated_row parameter in the SVOD environment
		this.curatedInterval = svod_env.curated_row ? setInterval(() => this.handleCuratedPrompt(), PEACOCK_CURATED_INTERVAL) : {};

		// enables the target asset prompt modal for peacock
		this.targetAssetInterval = svod_env.guided_experience && svod_env.guided_experience.target_asset_guide ? setInterval(() => this.handleTargetAssetPrompt(), PEACOCK_CURATED_INTERVAL) : {};

		// enables the home page prompt modal for peacock. This is only enabled by the parameter homepage_prompt parameter in the SVOD environment
		this.promptToHomePageInterval = svod_env.homepage_prompt ? setInterval(() => this.handlePromptToHomePage(), HOMEPAGE_PROMPT_INTERVAL) : {};

		this.onReceiveEvent({
			data: {
				event_type: "modal_close",
				modal_name: "welcome",
				page_location: "home_page",
				time: Date.now()
			}
		});

		this.setState({
			isFirstSVODLoad: false,
			beganSVODExperienceTime: Date.now(),
			modalBackgroundCover: false
		});
	}

	// begins the time interval once a user enters the Included with AppleTV page
	handleIncludedAppleTVPlusExperienceInterval() {
		this.setState({ promptedForceTargetAsset: true }, () => {
			this.endingAppleTVPlusExperienceInterval = setInterval(() => {
				this.onReceiveEvent({
					data: {
						event_type: "logout",
						completedTargetAsset: true,
						page_location: "svod_env",
						time: Date.now()
					}
				});
			}, TIME_ENTERING_EXIT_SURVEY);
		});
	}

	handleTrackerUpdate(updatedAnswerTracker, updatedPathTracker) {
		this.setState({
			pathTracker: updatedPathTracker,
			answerTracker: updatedAnswerTracker
		});
	}

	resetCuratedPagePrompt() {
		const { svod_env } = this.props.fetchedGroup;
		let environmentModal = this.grabEnvironmentModalType();
		window.$(`#${environmentModal}`).modal('close');

		clearInterval(this.curatedInterval);

		// enables the curated prompt modal for peacock. This is only enabled by the parameter curated_row parameter in the SVOD environment
		this.curatedInterval = svod_env.curated_row ? setInterval(() => this.handleCuratedPrompt(), PEACOCK_CURATED_INTERVAL) : {};

		this.onReceiveEvent({ data: { event_type: "modal_close", modal_name: "did_you_notice", page_location: "home_page", time: Date.now() } });
		this.setState({ promptCuratedRow: false, modalBackgroundCover: false });
	}

	resetPromptToHomePage() {
		const { svod_env } = this.props.fetchedGroup;
		let environmentModal = this.grabEnvironmentModalType();
		window.$(`#${environmentModal}`).modal('close');

		clearInterval(this.promptToHomePageInterval);
		// enables the home page prompt modal for peacock. This is only enabled by the parameter homepage_prompt parameter in the SVOD environment
		this.promptToHomePageInterval = svod_env.homepage_prompt ? setInterval(() => this.handlePromptToHomePage(), HOMEPAGE_PROMPT_INTERVAL) : {};

		this.onReceiveEvent({ data: { event_type: "modal_close", modal_name: "prompt_return_to_home_page", page_location: "", time: Date.now() } });
		this.setState({
			promptReturnToHomePage: false,
			modalBackgroundCover: false
		}, () => {
			setTimeout(() => {
				const peacockHomeButton = document.getElementById('profile-to-home-icon');
				if (peacockHomeButton) peacockHomeButton.click();
			}, 500);
		});
	}

	closeTransactionPrompt() {
		let { totalModalTime, enterModalTimestamp } = this.state;
		let environmentModal = this.grabEnvironmentModalType();

		const now = Date.now();
		const exitModalTimestamp = now;
		totalModalTime += exitModalTimestamp - enterModalTimestamp;

		window.$(`#${environmentModal}`).modal('close');

		this.onReceiveEvent({ data: { event_type: "modal_close", modal_name: "transaction", page_location: "transaction", time: Date.now() } });
		this.setState({ totalModalTime, modalBackgroundCover: false });
	}

	closeAppleTargetAssetPrompt() {
		const { fetchedGroup } = this.props;
		let { totalModalTime, enterModalTimestamp, svodContinueTime } = this.state;

		const isTargetShowPageGuide = isTargetAssetShowPagePrompt(fetchedGroup);
		let backRoute = this.state.backRoute;

		const now = Date.now();
		const exitModalTimestamp = now;
		totalModalTime += exitModalTimestamp - enterModalTimestamp;
		svodContinueTime = now;

		if (isTargetShowPageGuide) {
			backRoute = '/study/showpage';
		}

		let environmentModal = this.grabEnvironmentModalType();
		window.$(`#${environmentModal}`).modal('close');

		clearInterval(this.beginGuidedExperienceInterval);
		this.forceGuidedExperienceInterval = setInterval(() => this.forceGuidedExperience(), 1000);

		this.onReceiveEvent({
			data: {
				event_type: "modal_close",
				modal_name: "apple_prompt_to_target_asset",
				page_location: "svod_env",
				time: Date.now()
			}
		});

		this.setState({
			backRoute,
			totalModalTime,
			svodContinueTime,
			promptedTargetAsset: true,
			modalBackgroundCover: false,
		}, () => {
			setTimeout(() => {
				this.setState({
					autoNavigateToHome: false,
					autoNavigateToTargetAsset: false
				});
			}, 500);
		});
	}

	closeForceAppleTargetAssetPrompt() {
		const { fetchedGroup } = this.props;
		const { svod_env } = fetchedGroup;
		let { targetAssetIndex, totalModalTime, svodContinueTime, enterModalTimestamp } = this.state;

		const environmentModal = this.grabEnvironmentModalType();
		const isAppleTVGuided = isAppleTVGuidedTargetPrompt(fetchedGroup);
		const isTargetShowPageGuide = isTargetAssetShowPagePrompt(fetchedGroup);
		const isLastTargetAsset = svod_env && svod_env.target_assets && ((targetAssetIndex === svod_env.target_assets.length - 1) || targetAssetIndex === svod_env.target_asset_limiter - 1);
		const enabledForceGuidedExperienceInterval = !isTargetShowPageGuide || isLastTargetAsset;

		const now = Date.now();
		const exitModalTimestamp = now;
		totalModalTime += exitModalTimestamp - enterModalTimestamp;
		svodContinueTime = now;

		let backRoute = this.state.backRoute;
		if (isAppleTVGuided) backRoute = '/study/included-with-apple-tv';
		else if (isTargetShowPageGuide) backRoute = '/study/showpage';

		window.$(`#${environmentModal}`).modal('close');
		if (enabledForceGuidedExperienceInterval) clearInterval(this.forceGuidedExperienceInterval);

		this.onReceiveEvent({ data: { event_type: "modal_close", modal_name: "apple_force_to_target_asset", page_location: "svod_env", time: Date.now() } });
		this.setState({
			backRoute,
			totalModalTime,
			svodContinueTime,
			modalBackgroundCover: false,
			promptedForceTargetAsset: enabledForceGuidedExperienceInterval,
			autoNavigateToTargetAsset: true,
		}, () => {
			if (isTargetShowPageGuide) {
				setTimeout(() => {
					APPLE_GUIDED_EXPERIENCE_LIMIT = APPLE_GUIDED_ADDED_LIMIT;
					this.setState({
						beginAppleGuidedExperience: false,
						targetAssetIndex: targetAssetIndex + 1,
						autoNavigateToTargetAsset: false,
						promptedTargetAsset: enabledForceGuidedExperienceInterval
					});
				}, 1000);
			}

			if (enabledForceGuidedExperienceInterval) {
				this.handleIncludedAppleTVPlusExperienceInterval();
			}
		});
	}

	closeForceIncludedAppleTVPagePrompt() {
		const { fetchedGroup } = this.props;
		let { totalModalTime, svodContinueTime, enterModalTimestamp } = this.state;

		let environmentModal = this.grabEnvironmentModalType();
		let backRoute = this.state.backRoute;
		const isAppleTVGuided = isAppleTVGuidedTargetPrompt(fetchedGroup);

		const now = Date.now();
		const exitModalTimestamp = now;
		totalModalTime += exitModalTimestamp - enterModalTimestamp;
		svodContinueTime = now;

		window.$(`#${environmentModal}`).modal('close');
		clearInterval(this.forceGuidedExperienceInterval);

		if (isAppleTVGuided) backRoute = '/study/included-with-apple-tv';
		this.handleIncludedAppleTVPlusExperienceInterval();

		this.setState({
			backRoute,
			totalModalTime,
			svodContinueTime,
			modalBackgroundCover: false,
			promptedForceTargetAsset: true,
			autoNavigateToIncludedAppleTVPage: true,
		}, () => {
			this.onReceiveEvent({ data: { event_type: "modal_close", modal_name: "apple_force_to_target_asset", page_location: "svod_env", time: Date.now() } });
		});
	}

	closeReturnToContentPrompt() {
		let environmentModal = this.grabEnvironmentModalType();
		window.$(`#${environmentModal}`).modal('close');

		clearInterval(this.forceGuidedExperienceInterval);

		this.onReceiveEvent({ data: { event_type: "modal_close", modal_name: "apple_prompt_return_to_content", page_location: "", time: Date.now() } });
		this.setState({ modalBackgroundCover: false, promptedForceTargetAsset: true, autoNavigateToTargetAsset: true, returnToContentPromptCount: this.state.returnToContentPromptCount + 1 });
	}

	closeTargetAssetPrompt() {
		const { svod_env } = this.props.fetchedGroup;
		let environmentModal = this.grabEnvironmentModalType();
		window.$(`#${environmentModal}`).modal('close');

		clearInterval(this.targetAssetInterval);
		this.forcedTargetAssetInterval = svod_env.guided_experience && svod_env.guided_experience.target_asset_guide ? setInterval(() => this.handleForceTargetAssetPrompt(), PEACOCK_CURATED_INTERVAL) : {};
		// this.onReceiveEvent({ data: { event_type: "modal_close", modal_name: "apple_prompt_return_to_content", page_location: "", time: Date.now() } });
		this.setState({ modalBackgroundCover: false, promptedTargetAsset: true });
	}

	closeForceTargetAssetPrompt() {
		let environmentModal = this.grabEnvironmentModalType();
		window.$(`#${environmentModal}`).modal('close');
		// clearInterval(this.forcedTargetAssetInterval); // Commented out to allow forced entry again if the user leaves the target asset after the first time
		this.setState({ modalBackgroundCover: false, promptedForceTargetAsset: true, autoNavigateToTargetAsset: true });
	}

	resetTargetAssetPrompt() {
		let environmentModal = this.grabEnvironmentModalType();
		window.$(`#${environmentModal}`).modal('close');

		clearInterval(this.targetAssetInterval);
		this.targetAssetInterval = setInterval(() => this.setState({ promptTargetAsset: true }), 60000);

		this.onReceiveEvent({ data: { event_type: "modal_close", modal_name: "view_this_asset", page_location: "curated_page", time: Date.now() } });
		this.setState({ promptTargetAsset: false, modalBackgroundCover: false });
	}

	resetWatchPagePrompt() {
		let environmentModal = this.grabEnvironmentModalType();
		window.$(`#${environmentModal}`).modal('close');

		clearInterval(this.watchPageInterval);
		this.watchPageInterval = setInterval(() => this.setState({ promptWatchPage: true }), PROMPT_WATCH_PAGE_INTERVAL);

		this.onReceiveEvent({ data: { event_type: "modal_close", modal_name: "watch_episode", page_location: "show_page", time: Date.now() } });
		this.setState({ promptWatchPage: false, modalBackgroundCover: false });
	}

	closeFinalStepConfirmationModal() {
		let environmentModal = this.grabEnvironmentModalType();
		window.$(`#${environmentModal}`).modal('close');

		this.onReceiveEvent({
			data: {
				event_type: "modal_close",
				modal_name: "prompt_final_step_confirmation",
				page_location: "watch_page",
				time: Date.now()
			}
		});
		this.setState({ confirmedFinalStep: true, modalBackgroundCover: false });
	}

	returnUpdatedGoodwill(action) {
		Logger.log(this.constructor.name, "handleGoodwill() BEFORE - ACTION:", action, "GOODWILL:", this.state.goodwill);
		const isTester = TargetProcess.isTester(this.props.targetParams);
		let updatedGoodwill = { ...this.state.goodwill };
		let allotment = updatedGoodwill.allotment;

		if (action === 'lose_token' && !isTester) {
			updatedGoodwill.tokens > 0 ? updatedGoodwill.tokens-- : updatedGoodwill.tokens = 0;
			Logger.log(this.constructor.name, "handleGoodwill(): goodwillbank is taking a token", updatedGoodwill);
		}
		else {
			Logger.log("handleGoodwill(): goodwillbank processing '" + action + "' earning.  We've alotted up to " + allotment[action] + " tokens for this.");

			if (allotment[action] > 0) {
				allotment[action]--;
				updatedGoodwill.tokens++;
				Logger.log(this.constructor.name, "handleGoodwill(): goodwillbank is returning you a token", updatedGoodwill);
			}
		}
		return updatedGoodwill;
	}

	onReady() {
		// Logger.log(this.constructor.name, "onReady()");
	}

	isSurveyReady() {
		let { questionIndex, questionSetIndex, maxQsetIndex } = this.state;
		if (this.props.fetchedPanel && this.state.enableSurveySet) {
			return true;
		}
		return false;
	}

	returnResponseWithDates(environment_response) {
		const EVENT_TYPES = ['poster', 'tile', 'show_details', 'fullscreen'];

		environment_response.start_time_in_env = new Date(environment_response.start_time_in_env);
		environment_response.end_time_in_env = new Date(environment_response.end_time_in_env);

		if (environment_response.asset_activity &&
			environment_response.asset_activity.length
		) {
			for (let i = 0; i < environment_response.asset_activity.length; i++) {
				let assetActivityItem = environment_response.asset_activity[i];

				EVENT_TYPES.forEach((event_type) => {
					if (assetActivityItem[event_type] &&
						assetActivityItem[event_type].time_interacted_with &&
						assetActivityItem[event_type].time_interacted_with.length
					) {
						for (let k = 0; k < assetActivityItem[event_type].time_interacted_with.length; k++) {
							let updatedInteraction = assetActivityItem[event_type].time_interacted_with[k];
							updatedInteraction.start_time = new Date(updatedInteraction.start_time);
							updatedInteraction.end_time = new Date(updatedInteraction.end_time);
							environment_response.asset_activity[i][event_type].time_interacted_with[k] = updatedInteraction;
						}
					}
				});
			}
		}

		if (environment_response.row_activity &&
			environment_response.row_activity.length
		) {
			for (let i = 0; i < environment_response.row_activity.length; i++) {
				let rowActivityItem = environment_response.row_activity[i];

				if (rowActivityItem.time_interacted_with && rowActivityItem.time_interacted_with.length) {
					for (let k = 0; k < rowActivityItem.time_interacted_with.length; k++) {
						let updatedInteraction = rowActivityItem.time_interacted_with[k];
						updatedInteraction.start_time = new Date(updatedInteraction.start_time);
						updatedInteraction.end_time = new Date(updatedInteraction.end_time);

						environment_response.row_activity[i].time_interacted_with[k] = updatedInteraction;
					}
				}
			}
		}

		if (environment_response.my_list_activity &&
			environment_response.my_list_activity.time_interacted_with &&
			environment_response.my_list_activity.time_interacted_with.length
		) {
			let asset_activity = environment_response.my_list_activity;
			for (let k = 0; k < asset_activity.time_interacted_with.length; k++) {
				let updatedInteraction = asset_activity.time_interacted_with[k];
				updatedInteraction.start_time = new Date(updatedInteraction.start_time);
				updatedInteraction.end_time = new Date(updatedInteraction.end_time);

				environment_response.my_list_activity.time_interacted_with[k] = updatedInteraction;
			}
		}

		return environment_response;
	}

	returnFeedbackType(screenCode) {
		if (screenCode) {
			if (screenCode !== 'thankyou') {
				return 'terminate';
			}
			return 'thankyou';
		}
		return '';
	}

	returnAssetsInfo(group) {
		// Logger.log(this.constructor.name, "returnAssetsInfo() GETTING ASSETS INFO");
		// assetsInfoMap: { }
		// rowInfoMap: { }
		// midRowInfoMap: { }
		// myListInfoMap: { }
		let assetsInfoMap = {};
		let rowInfoMap = {};
		let midRowInfoMap = {};
		let promosInfoMap = {};
		let billboardAsset = null;

		if (group && group.svod_env && group.svod_env.rows && group.svod_env.rows.length) {
			const isSvodPeacock = group.svod_env.environment_vendor === EnvType.PEACOCK;
			group.svod_env.rows.forEach((row) => {
				if (row.assets && row.assets.length) {
					row.assets.forEach((asset) => {
						if (asset.video && asset.video.duration) {
							assetsInfoMap[asset._id] = {
								_id: asset._id,
								name: asset.name,
								duration: asset.video.duration,
								content_type: asset.content_type,
								control: !!asset.control,
								count: 0,
								total_time_on_tile: 0,
								added_to_wishlist: false,
								position_in_billboard: null,
								type: null,
								poster: {
									trailer_completion: 0,
									play: false,
									add_to_list: false,
									rating: null,
									time_interacted_with: []
								},
								tile: {
									trailer_completion: 0,
									play: false,
									add_to_list: false,
									rating: null,
									time_interacted_with: []
								},
								show_details: {
									trailer_completion: 0,
									play: false,
									add_to_list: false,
									rating: null,
									commented: false,
									time_interacted_with: []
								},
								fullscreen: {
									completion: 0,
									time_interacted_with: []
								}
							};

							midRowInfoMap[asset._id] = {
								id: asset._id,
								label: asset.name,
								time_in_view: [],
								time_interacted_with: []
							};
						}

						if (!billboardAsset && isSvodPeacock && row.label !== ROW_LABELS.BILLBOARD) {
							billboardAsset = asset;
						}
					});
				}

				if (row.id) {
					rowInfoMap[row.id] = {
						id: row.id,
						label: row.label,
						time_in_view: [],
						time_interacted_with: []
					};
				}
			});
		}

		if (group && group.svod_env && group.svod_env.appletv_plus_rows && group.svod_env.appletv_plus_rows.length) {
			group.svod_env.appletv_plus_rows.forEach((row) => {
				if (row.assets && row.assets.length) {
					row.assets.forEach((asset) => {
						if (asset.video) {
							assetsInfoMap[asset._id] = {
								_id: asset._id,
								name: asset.name,
								duration: asset.video.duration,
								content_type: asset.content_type,
								control: !!asset.control,
								count: 0,
								total_time_on_tile: 0,
								added_to_wishlist: false,
								position_in_billboard: null,
								type: null,
								poster: {
									trailer_completion: 0,
									play: false,
									add_to_list: false,
									rating: null,
									time_interacted_with: []
								},
								tile: {
									trailer_completion: 0,
									play: false,
									add_to_list: false,
									rating: null,
									time_interacted_with: []
								},
								show_details: {
									trailer_completion: 0,
									play: false,
									add_to_list: false,
									rating: null,
									commented: false,
									time_interacted_with: []
								},
								fullscreen: {
									completion: 0,
									time_interacted_with: []
								}
							};

							midRowInfoMap[asset._id] = {
								id: asset._id,
								label: asset.name,
								time_in_view: [],
								time_interacted_with: []
							};
						}
					});
				}

				if (row.id) {
					rowInfoMap[row.id] = {
						id: row.id,
						label: row.label,
						time_in_view: [],
						time_interacted_with: []
					};
				}
			});
		}

		if (group
			&& group.svod_env
			&& group.svod_env.target_promo_assets
			&& group.svod_env.target_promo_assets.length
		) {
			group.svod_env.target_promo_assets.forEach((promoSet) => {
				if (promoSet && promoSet.length) {
					promoSet.forEach((promoAsset) => {
						if (promoAsset.video && promoAsset.video.duration) {
							promosInfoMap[promoAsset._id] = {
								_id: promoAsset._id,
								name: promoAsset.name,
								duration: promoAsset.video.duration,
								control: !!promoAsset.control,
								count: 0,
								type: null,
								fullscreen: {
									completion: 0,
									time_interacted_with: []
								}
							};
						}
					});
				}
			});
		}
		return { assetsInfoMap, rowInfoMap, promosInfoMap, billboardAsset };
	}

	returnParams() {
		let group_id = null;
		let panelSegmentIndex = null;

		if (this.props.targetParams && this.props.targetParams.test && parseInt(this.props.targetParams.test) === 1) {
			group_id = this.props.targetParams.gid;
			panelSegmentIndex = this.props.targetParams.panelSegmentIndex || this.props.targetParams.ps || 0;
			panelSegmentIndex = parseInt(panelSegmentIndex);

		} else {
			if (this.props.targetParams
				&& this.props.targetParams.gid
				&& (typeof this.props.targetParams.panelSegmentIndex === 'number')
			) {
				group_id = this.props.targetParams.gid;
				panelSegmentIndex = this.props.targetParams.panelSegmentIndex;
			}
			else if (this.props.fetchedGroup
				&& this.props.fetchedGroup._id
				&& (typeof this.props.fetchedGroupPanelSegment === 'number')
			) {
				group_id = this.props.fetchedGroup._id;
				panelSegmentIndex = this.props.fetchedGroupPanelSegment;
			}
		}

		return {
			group_id,
			panelSegmentIndex
		};
	}

	returnQuestionMap(panel) {
		let questionMap = {};
		if (panel.questions && panel.questions.length) {
			let clonedPanel = { ...panel };
			clonedPanel.questions.forEach((question) => {
				questionMap[question.qid] = question;
			});
		}
		return questionMap;
	}

	returnQuestionSetInit(panel) {
		let questionIndex = this.state.questionIndex;
		let questionSetIndex = this.state.questionSetIndex;

		if (panel && panel.questions && panel.questions.length) {
			for (let qIndex = 0; qIndex < panel.questions.length; qIndex++) {
				const question = panel.questions[qIndex];

				if (!PANEL_HELPERS.isSurveyPrompt(question)
					&& !PANEL_HELPERS.isConditionalAidQuestion(question)
					&& !PANEL_HELPERS.isConditionalLogicQuestion(question)
				) {
					questionIndex = qIndex;
					questionSetIndex = question.qset_index;
					break;
				}
			}
		}
		return { questionIndex, questionSetIndex };
	}

	returnQuestionSetMap(panel) {
		let questionSetMap = {};
		if (panel && panel.questions && panel.questions.length) {
			panel.questions.forEach((question) => {
				if (!questionSetMap[question.qset_index]) { questionSetMap[question.qset_index] = []; }
				questionSetMap[question.qset_index].push(question);
			});

			// console.log('QUESTION SET MAP:', questionSetMap);
			for (let setIndex in questionSetMap) {
				if (questionSetMap[setIndex] && questionSetMap[setIndex].length) {
					questionSetMap[setIndex] = helpers.sortArrayofObjects(questionSetMap[setIndex]);
				}
			}

			return questionSetMap;
		}
		return null;
	}

	returnMaxQsetIndex(panel) {
		let maxQsetIndex = 0;
		if (panel && panel.questions && panel.questions.length) {
			panel.questions.forEach((question) => {
				maxQsetIndex = question.qset_index > maxQsetIndex ? question.qset_index : maxQsetIndex;
			});
		}
		return maxQsetIndex;
	}

	renderModalButtons() {
		const { fetchedGroup } = this.props;
		const { svod_env } = fetchedGroup;

		switch (this.state.modalType) {
			case 'logout': {
				return (
					<div>
						<Button className='no-modal-btn red'
							onClick={() => this.handleCloseModal()}>
							<FormattedMessage
								id="env_container.modal.button.no"
								defaultMessage={`Cancel`}
							/>
						</Button>

						<Button className='yes-modal-btn'
							onClick={() => this.handleQsetIndex('exit')}
							style={{ marginLeft: '-10px', marginRight: '10px' }}>
							<FormattedMessage
								id="env_container.modal.button.exit_to_survey"
								defaultMessage={`Exit to Survey`}
							/>
						</Button>
					</div>
				);
			}
			case 'timeout': {
				return (
					<div>
						<Button className='yes-modal-btn'
							onClick={() => {
								if (this.props.environment === EnvType.APPLETV) {
									this.handleTermination(this.props.fetchedGroup, SCREEN_CODES.SESSION_TIMEOUT, "terminate", {}, SCREEN_REASONS.SESSION_LENGTH);
								} else {
									this.handleQsetIndex('exit');
								}
							}}
							style={{ marginLeft: '-10px', marginRight: '10px' }}>
							<FormattedMessage
								id="env_container.modal.button.continue"
								defaultMessage={`Continue`}
							/>
						</Button>
					</div>
				);
			}
			case 'force-logout': {
				return (
					<div>
						<Button className='yes-modal-btn'
							onClick={() => {
								this.onReceiveEvent({ data: { event_type: "modal_button_click", modal_name: "logout", page_location: "watch_page", time: Date.now() } });
								this.handleQsetIndex('exit');
							}}
							style={{ marginLeft: '-10px', marginRight: '10px' }}>
							<FormattedMessage
								id="env_container.modal.button.continue_to_survey"
								defaultMessage={`Continue to Survey`}
							/>
						</Button>
					</div>
				);
			}
			case 'prompt_curated_content': {
				return (
					<div>
						<Button className='yes-modal-btn'
							onClick={() => {
								this.onReceiveEvent({ data: { event_type: "modal_button_click", modal_name: "did_you_notice", page_location: "home_page", time: Date.now() } });
								this.resetCuratedPagePrompt();
							}}
							style={{ marginLeft: '-10px', marginRight: '10px' }}>
							<FormattedMessage
								id="env_container.modal.button.continue"
								defaultMessage={`Continue`}
							/>
						</Button>
					</div>
				);
			}
			case 'display_welcome_modal': {
				return (
					<div>
						<Button className='yes-modal-btn'
							onClick={() => {
								this.onReceiveEvent({
									data: {
										event_type: "modal_button_click",
										modal_name: "welcome",
										page_location: "home_page",
										time: Date.now()
									}
								});
								this.handleClosePeacockWelcomeModal();
							}}
							style={{ marginLeft: '-10px', marginRight: '10px' }}>
							<FormattedMessage
								id="env_container.modal.button.explore"
								defaultMessage={`Explore`}
							/>
						</Button>
					</div>
				);
			}
			case 'peacock_prompt_to_target_asset': {
				const isSVODHome = isCurrentSVODEnvironmentPage(document.location, '/study');
				const isSVODWatchPage = isCurrentSVODEnvironmentPage(document.location, '/study/watch');

				const clickEvent = {
					data: {
						event_type: "modal_button_click",
						modal_name: "peacock_prompt_to_target_asset",
						page_location: "svod_env",
						time: Date.now()
					}
				};

				let buttonDisplay = (
					<Button className='yes-modal-btn'
						onClick={() => {
							this.onReceiveEvent(clickEvent);
							this.closeTargetAssetPrompt();
						}}
						style={{ marginLeft: '-10px', marginRight: '10px' }}>

						<FormattedMessage id="env_container.modal.button.continue" defaultMessage={`Continue`} />
					</Button>
				);

				// /study
				if (!isSVODHome || this.state.autoNavigateToHome) {
					buttonDisplay = (
						<Button className='yes-modal-btn'
							onClick={() => {
								this.onReceiveEvent(clickEvent);
								this.setState({
									autoNavigateToHome: true
								}, () => {
									const timeoutSeconds = isSVODWatchPage ? 1000 : 0;
									setTimeout(() => {
										this.closeTargetAssetPrompt();
									}, timeoutSeconds);
								});
							}}
							style={{ marginLeft: '-10px', marginRight: '10px' }}>

							<FormattedMessage id="env_container.modal.button.to_homepage" defaultMessage={`To Homepage`} />
						</Button>
					);
				}

				return (
					<div>
						{buttonDisplay}
					</div>
				);
			}
			case 'peacock_force_to_target_asset': {
				const closePromptFunction = this.closeForceTargetAssetPrompt;
				let event = {
					data: {
						event_type: "modal_button_click",
						modal_name: "peacock_force_to_target_asset",
						page_location: "",
						time: Date.now()
					}
				};
				return (
					<div>
						<Button className='yes-modal-btn'
							onClick={() => {
								this.onReceiveEvent(event);
								closePromptFunction();
							}}
							style={{ marginLeft: '-10px', marginRight: '10px' }}>
							<FormattedMessage
								id="env_container.modal.button.continue"
								defaultMessage={`Continue`}
							/>
						</Button>
					</div>
				);
			}
			case 'prompt_return_to_home_page': {
				return (
					<div>
						<Button className='yes-modal-btn'
							onClick={() => {
								this.onReceiveEvent({ data: { event_type: "modal_button_click", modal_name: "prompt_return_to_home_page", page_location: "", time: Date.now() } });
								this.resetPromptToHomePage();
							}}
							style={{ marginLeft: '-10px', marginRight: '10px' }}>
							<FormattedMessage
								id="env_container.modal.button.continue"
								defaultMessage={`Continue`}
							/>
						</Button>
					</div>
				);
			}
			case 'transaction': {
				return (
					<div>
						<Button className='yes-modal-btn'
							onClick={() => {
								this.onReceiveEvent({ data: { event_type: "modal_button_click", modal_name: "transaction", page_location: "transaction", time: Date.now() } });
								this.closeTransactionPrompt();
							}}
							style={{ marginLeft: '-10px', marginRight: '10px' }}>
							OK
						</Button>
					</div>
				);
			}
			case 'apple_prompt_to_target_asset': {
				const isSVODHome = isCurrentSVODEnvironmentPage(document.location, '/study');
				const isSVODWatchPage = isCurrentSVODEnvironmentPage(document.location, '/study/watch');
				const isAppleTVGuided = isAppleTVGuidedTargetPrompt(fetchedGroup);
				const isShowPageTargetGuided = isTargetAssetShowPagePrompt(fetchedGroup);

				const clickEvent = {
					data: {
						event_type: "modal_button_click",
						modal_name: "apple_prompt_to_target_asset",
						page_location: "svod_env",
						time: Date.now()
					}
				};

				let buttonDisplay = (
					<Button className='yes-modal-btn'
						onClick={() => {
							this.onReceiveEvent(clickEvent);
							this.closeAppleTargetAssetPrompt();
						}}
						style={{ marginLeft: '-10px', marginRight: '10px' }}>

						<FormattedMessage id="env_container.modal.button.i_understand" defaultMessage={`I Understand`} />
					</Button>
				);

				// /study
				if (isAppleTVGuided && (!isSVODHome || this.state.autoNavigateToHome)) {
					buttonDisplay = (
						<Button className='yes-modal-btn'
							onClick={() => {
								this.onReceiveEvent(clickEvent);
								this.setState({
									autoNavigateToHome: true
								}, () => {
									const timeoutSeconds = isSVODWatchPage ? 1000 : 0;
									setTimeout(() => {
										this.closeAppleTargetAssetPrompt();
									}, timeoutSeconds);
								});
							}}
							style={{ marginLeft: '-10px', marginRight: '10px' }}>

							<FormattedMessage id="env_container.modal.button.to_homepage" defaultMessage={`To Homepage`} />
						</Button>
					);
				}

				return (
					<div>
						{buttonDisplay}
					</div>
				);
			}
			case 'apple_force_to_target_asset': {
				const isAppleTVGuided = svod_env && svod_env.guided_experience && svod_env.guided_experience.included_appletv_page;
				let event = { data: { event_type: "modal_button_click", modal_name: "apple_force_to_target_asset", page_location: "", time: Date.now() } };
				let closePromptFunction = this.closeForceAppleTargetAssetPrompt;

				if (isAppleTVGuided) {
					event = { data: { event_type: "modal_button_click", modal_name: "apple_force_to_included_appletv_page", page_location: "svod_env", time: Date.now() } };
					closePromptFunction = this.closeForceIncludedAppleTVPagePrompt;
				}

				return (
					<div>
						<Button className='yes-modal-btn'
							onClick={() => {
								this.onReceiveEvent(event);
								closePromptFunction();
							}}
							style={{ marginLeft: '-10px', marginRight: '10px' }}>
							<FormattedMessage
								id="env_container.modal.button.i_understand"
								defaultMessage={`I Understand`}
							/>
						</Button>
					</div>
				);
			}
			case 'apple_prompt_return_to_content': {
				return (
					<div>
						<Button className='yes-modal-btn'
							onClick={() => {
								this.onReceiveEvent({ data: { event_type: "modal_button_click", modal_name: "apple_prompt_return_to_content", page_location: "svod_env", time: Date.now() } });
								this.closeReturnToContentPrompt();
							}}
							style={{ marginLeft: '-10px', marginRight: '10px' }}>
							<FormattedMessage
								id="env_container.modal.button.continue"
								defaultMessage={`Continue`}
							/>
						</Button>
					</div>
				);
			}
			case 'prompt_final_step_confirmation': {
				return (
					<div>
						<Button className='yes-modal-btn'
							onClick={() => {
								this.onReceiveEvent({ data: { event_type: "modal_button_click", modal_name: "prompt_final_step_confirmation", page_location: "watch_page", time: Date.now() } });
								this.closeFinalStepConfirmationModal();
							}}
							style={{ marginLeft: '-10px', marginRight: '10px' }}>
							<FormattedMessage
								id="env_container.modal.button.continue"
								defaultMessage={`Continue`}
							/>
						</Button>
					</div>
				);
			}
			case 'prompt_target_asset': {
				return (
					<div>
						<Button className='yes-modal-btn'
							onClick={() => {
								this.onReceiveEvent({ data: { event_type: "modal_button_click", modal_name: "view_this_asset", page_location: "curated_page", time: Date.now() } });
								this.resetTargetAssetPrompt();
							}}
							style={{ marginLeft: '-10px', marginRight: '10px' }}>
							<FormattedMessage
								id="env_container.modal.button.continue"
								defaultMessage={`Continue`}
							/>
						</Button>
					</div>
				);
			}
			case 'prompt_watch_page': {
				return (
					<div>
						<Button className='yes-modal-btn'
							onClick={() => {
								this.onReceiveEvent({ data: { event_type: "modal_button_click", modal_name: "watch_episode", page_location: "show_page", time: Date.now() } });
								this.resetWatchPagePrompt();
							}}
							style={{ marginLeft: '-10px', marginRight: '10px' }}>
							<FormattedMessage
								id="env_container.modal.button.continue"
								defaultMessage={`Continue`}
							/>
						</Button>
					</div>
				);
			}
		}
		return "";
	}

	render() {
		// Logger.log(this.constructor.name, "render()", this.props, this.state);
		const { feedbackType, questionIndex, questionSetIndex, maxQsetIndex } = this.state;

		if (feedbackType) {
			this.stopUserActiveTimer();
			return <Feedback feedbackType={feedbackType} {...this.props} />;
		}

		let displaySurvey = this.isSurveyReady();
		const language = this.props.intl && this.props.intl.locale ? this.props.intl.locale : "en";
		// let svodStyles = { color: 'white', padding: '15px', fontSize: '16px', display: 'block', margin: 'auto', textAlign: 'center', position: 'relative', top: '45%' };

		// Logger.log(this.constructor.name, "render() QINDEX:", questionIndex, "QSET-INDEX:", questionSetIndex);

		let modalActionBtns = this.renderModalButtons();
		{/*
			Survey module accepts a new property called pathSuffix. We're using the asset_id for this prop.

			When we have qsets depending on an asset, we’re adding asset_ids to the panel response, but if theres a path related to the question or answer the path_id needs to be unique to the asset_id

			The asset_id gets added at the end of the path_id. If it isnt there, then a question with a path will always appear no matter what answer gets selected once the path has been added to the pathTracker
			- EG
		*/}
		let environmentModal = this.grabEnvironmentModalType();

		return (
			<div className="pilotly-player"
				style={{ height: '100vh', width: '100vw', background: 'black', overflow: 'hidden', color: 'white' }}>
				<PageLoader loading={!this.props.fetchedPanel} small={true} />

				{this.props.fetchedPanel && displaySurvey ?
					<FadeIn show={displaySurvey} addedClass={displaySurvey ? "position-relative" : "position-absolute top-0"}>
						<Survey {...this.props}
							timeout={500}
							language={language}
							settings={settings}
							// question={currentQuestion}
							intiQuestionIndex={questionIndex}
							intiQuestionSetIndex={questionSetIndex}
							pathSuffix={this.state.qset_asset} // some questions are referring to a specific video asset, when this happens we use the asset id to make the path unique to that specific video
							pathTracker={this.state.pathTracker}
							answerTracker={this.state.answerTracker} // answer tracker is used for hidden logic conditional questions?
							questionContainerClass="pilotly-player"
							handleProgressUpdate={this.handleProgressUpdate}
							handlePanelResponse={this.handlePanelResponse}
							handleBadRespondents={this.handleBadRespondents}
							handleTermination={this.handleTermination}
							handleQuestionIndexOverride={this.handleQuestionIndexOverride}
							handleTrackerUpdate={this.handleTrackerUpdate}
						/>
					</FadeIn>
					: ''
				}

				{this.props.fetchedPanel && !displaySurvey ?
					<FadeIn show={this.props.fetchedPanel && !displaySurvey} addedClass={!displaySurvey ? "position-relative" : "position-absolute top-0"}>
						<SVOD
							{...this.props}
							currentAssetComments={this.state.currentAssetComments}
							isFirstSVODLoad={this.state.isFirstSVODLoad}
							beganSVODExperienceTime={this.state.beganSVODExperienceTime}
							svodStartTime={this.state.svodStartTime}
							svodContinueTime={this.state.svodContinueTime}
							totalModalTime={this.state.totalModalTime}
							billboardAsset={this.state.billboardAsset}

							createViewerComment={this.createViewerComment}
							loadAssetComments={this.loadAssetComments}
							eventHandler={this.onReceiveEvent}
							handleIncludedAppleTVPlusExperienceInterval={this.handleIncludedAppleTVPlusExperienceInterval}
							handleSVODPanelResponses={this.handleSVODPanelResponses}
							handleBillboardAsset={this.handleBillboardAsset}
							forceLogout={IS_DEVELOPMENT_ENV ? () => this.handleTimedExperience(true) : null}

							targetAssetIndex={this.state.targetAssetIndex}
							promptReturnToHomePage={this.state.promptReturnToHomePage}
							promptCuratedRow={this.state.promptCuratedRow}
							promptWatchPage={this.state.promptWatchPage}
							promptTargetAsset={this.state.promptTargetAsset}
							promptedTargetAsset={this.state.promptedTargetAsset}
							promptForcedTargetAsset={this.state.promptForcedTargetAsset}
							promptedForceTargetAsset={this.state.promptedForceTargetAsset}
							forceGuidedExperience={this.state.forceGuidedExperience}
							beginAppleGuidedExperience={this.state.beginAppleGuidedExperience}
							autoNavigateToTargetAsset={this.state.autoNavigateToTargetAsset}
							autoNavigateToIncludedAppleTVPage={this.state.autoNavigateToIncludedAppleTVPage}
							confirmedFinalStep={this.state.confirmedFinalStep}
							pathTracker={this.state.pathTracker}
							backRoute={this.state.backRoute}
							autoNavigateToHome={this.state.autoNavigateToHome}
							surveyLayerActive={displaySurvey}
							isTester={this.isTester}
						/>
					</FadeIn>
					: ''
				}

				{!displaySurvey ?
					<PilotlyModal
						id={environmentModal}
						header={this.state.modalTitle}
						message={this.state.modalMessage}
						actions={modalActionBtns}
						backgroundCover={this.state.modalBackgroundCover}
					/>
					: ''
				}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		isSurveyActive: state.SVOD.isSurveyActive,
		currentUser: state.currentUser.currentUser,
		currentUserLocation: state.currentUser.currentUserLocation,

		fetchedDistributionList: state.targetProcess.fetchedDistributionList,
		fetchedGroup: state.targetProcess.fetchedGroup,
		fetchedPanel: state.targetProcess.fetchedPanel,
		targetParams: state.targetProcess.targetParams,

		userDisclaimer: state.currentUser.userDisclaimer,
		tracker: state.GlobalAnalyticsAdapterReducer.gaTracker,
		globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		setFetchedPanel,
		toggleActiveSurvey,
		setSelectedAsset: (asset) => dispatch(setSelectedAsset(asset)),
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(EnvironmentContainer));



// WEBPACK FOOTER //
// ./src/pages/EnvironmentContainer.js